// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:34:06.992Z
// Property: Isabella Court (ID: 6767906449167638)
// Collections: 13 amenities, 2 floorplans (live), 71 photos, 47 POIs, 5 reviews, 5 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167638",
  "property_external_id": "1816560",
  "property_zillow_url": "https://www.zillow.com/apartments/leland-nc/isabella-court/CjT6W5/",
  "property_apartments_url": "https://www.apartments.com/isabella-court-leland-nc/dl3jgkl/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57156159150",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "isabella-court",
  "property_name": "Isabella Court",
  "property_website_url": "https://www.isabellacourthomes.com",
  "property_domain": "https://www.isabellacourthomes.com",
  "property_address": "2007 Isabella Park Blvd",
  "property_full_address": "2007 Isabella Park Blvd, Leland, NC 28451",
  "property_address_1": "2007 Isabella Park Blvd",
  "property_address_2": null,
  "property_address_city": "Leland",
  "property_address_state": "NC",
  "property_address_zip_full": "28451",
  "property_address_zip": "28451",
  "property_address_country": "US",
  "property_address_county": "Brunswick County",
  "property_neighborhood_address": "Brunswick County",
  "property_address_latitude": "34.283883",
  "property_address_longitude": "-78.131848",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(833) 365-4890",
  "property_call_tracking_phone": "833-365-7850",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Single-family homes",
  "property_short_description": "<p><strong>Brand-new rental-home living near Wilmington’s coastal energy.</strong> Isabella Court pairs spacious three- and four-bedroom layouts with polished finishes, fenced backyards, lawn maintenance, and professional service—making everyday living streamlined from move-in to weekend plans. <a href=\"/schedule-a-tour\">Schedule a tour</a> to see it for yourself.</p>",
  "property_long_description": "<p><strong>Brand-new rental-home living, minutes from Wilmington’s coastal energy.</strong> At Isabella Court, you get the space and ease of a three- or four-bedroom home with the streamlined service of a professionally managed community. Choose from spacious Kershaw and Evans layouts with <a href=\"/amenities\">high-end finishes</a> like granite countertops, Energy-Star stainless steel appliances, luxury flooring, smart-home technology, in-unit laundry, generous closets, and fenced-in backyards—plus lawn maintenance that keeps weekends open.</p><p>Set in Leland, Isabella Court places you close to everyday shopping and dining while keeping the Cape Fear region within easy reach. Explore boardwalk trails at Westgate Nature Park, paddle or hike through 900-plus-acre Brunswick Nature Park, spend an afternoon at Brunswick Riverwalk at Belville, or cross over to downtown Wilmington for the Riverwalk, restaurants, museums, and riverfront views of Battleship North Carolina. With a dog park, concierge service, and flexible deposit alternative, Isabella Court makes coastal Carolina living feel polished, practical, and refreshingly uncomplicated. <a href=\"/schedule-a-tour\">Schedule a tour</a> and see it for yourself.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-0eb8-77c2-9318-b66a5dadb8d4.webp",
  "property_featured_image_media": {
    "alt_text": "Two-story houses with garages and manicured lawns under a cloudy sky.",
    "public_id": "019fec2e-0eb8-77c2-9318-b66a5dadb8d4",
    "storage_key": "property/6767906449167638/019fec2e-0eb8-77c2-9318-b66a5dadb8d4.webp",
    "width": 1280,
    "height": 902
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167638/01a0c017-e245-728e-8919-5b43f00d5cef.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c017-e245-728e-8919-5b43f00d5cef",
    "storage_key": "property/6767906449167638/01a0c017-e245-728e-8919-5b43f00d5cef.mp4",
    "thumbnail_key": "property/6767906449167638/01a0c017-e245-728e-8919-5b43f00d5cef_thumb.webp",
    "size_bytes": 21819201,
    "classification": "Community",
    "title": "Explore Our Beautiful New Home Community",
    "description": "Take a virtual tour of our stunning community, showcasing modern homes, well-maintained streets, and lush green spaces. Discover your dream home today."
  },
  "property_total_units": "168",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": "13",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.04761904761905",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge package $10.95, landscaping $97, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time, per home). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval from Quinn Property Management. Pet screening is required before move-in. Fish tanks limited to 20 gallons; no visiting animals.",
  "property_pet_policy_description": "Pet Screening is mandatory. Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, American Bulldog, or any crossbreeds. Maximum weight limit is 100 lbs per pet. No more than two pets allowed unless written approval is obtained. Non‑refundable pet fee: $300 for one pet; $500 for up to two pets. Monthly pet rent: $35 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://isabellacourthomes.securecafe.com/onlineleasing/isabella-court0/floorplans.aspx",
  "property_resident_portal_url": "https://isabellacourthomes.securecafenet.com/residentservices/isabella-court0/userlogin",
  "property_apply_now_url": "https://isabellacourthomes.securecafe.com/onlineleasing/isabella-court0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://isabellacourthomes.com/shared/images/isabella-court-a-quinn-residence-logo-ajurwkju.png",
  "property_primary_logo_media": null,
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#212f3a",
  "property_secondary_color": "#abb4ab",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 2.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "1709 - 1951",
  "property_sqft_min": "1709",
  "property_sqft_max": "1951",
  "property_price_range": "2036 - 2409",
  "property_price_min": "2036",
  "property_price_max": "2409",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61563343066873",
  "property_instagram_url": "https://www.instagram.com/isabellacourthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJod7BvUEXqokR9F-X7uYkTxo",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Isabella Court",
  "property_home_romance_title": "Experience Joyful Living in Your Perfect Rental Home",
  "property_home_amenities_blurb": "<p><strong>Comfort and convenience, close to home.</strong> Isabella Court pairs polished hardwood-style flooring, fenced-in backyards, generous closets, and in-home washer and dryer with everyday kitchen essentials like efficient appliances, a dishwasher, microwave, and refrigerator. Step outside to simplified living with lawn maintenance, concierge service, and a dog park designed for extra room to roam.</p>",
  "property_home_floorplans_blurb": "<p><strong>Two smart layouts, plenty of room to land.</strong> Choose a spacious three-bedroom Kershaw or flexible four-bedroom Evans at Isabella Court, where open living areas, stainless steel appliances, granite countertops, luxury flooring, in-unit laundry, generous closets, and fenced-in backyards bring everyday ease to rental home living in Leland.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture the details at Isabella Court.</strong> Preview bright two-story rental homes in Leland with open living spaces, light wood-style flooring, white cabinetry, granite countertops, and stainless steel appliances. From French doors and generous closets to fenced backyards that bring more room outdoors, the gallery highlights clean finishes and practical touches worth seeing up close.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Leland, mapped out with ease.</strong> Isabella Court puts everyday shopping at Waterford Village and the Shoppes at Westgate close by, with Brunswick Beer &amp; Cider, Leland Smoke House, and the Leland Cultural Arts Center adding local flavor. For fresh air, follow the trails, boardwalks, and river views at Founders Park, Westgate Nature Park, or Brunswick Riverwalk at Belville—then cross the Cape Fear River for downtown Wilmington’s dining, shops, museums, and weekend energy.</p>",
  "property_home_reviews_blurb": "<p><strong>What earns Isabella Court high marks?</strong> Reviewers point to easy self-guided tours, helpful leasing support, and homes that make a strong first impression. From spacious layouts and modern kitchens to high ceilings, generous closets, smart home features, and yards, the details stand out quickly. See what residents and visitors are saying, then explore the reviews for the full story.</p>",
  "property_neighborhood_blurb": "<p><strong>Use the map as your local shortcut.</strong> From Isabella Court, Leland opens up in easy layers: everyday stops around Waterford Village and the Shoppes at Westgate, local flavor at Brunswick Beer &amp; Cider or Leland Smoke House, and arts programming at the Leland Cultural Arts Center.</p><p>When you want fresh air, trade the road for boardwalks, trails, and river views at Founders Park, Westgate Nature Park, or the Brunswick Riverwalk at Belville. Just across the Cape Fear River, downtown Wilmington adds riverfront restaurants, shops, museums, and weekend energy while Leland keeps the pace relaxed and convenient. Explore the pins below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this connected coastal setting works from home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, built into the details.</strong> At Isabella Court, amenities start right where you live: fenced-in backyards, generous closets, in-home washer and dryer, and polished hardwood-style flooring that gives your space a finished feel. In the kitchen, efficient appliances, a dishwasher, microwave, and refrigerator keep daily routines simple, while air conditioning and an electronic thermostat help you stay comfortable through Leland’s warm coastal seasons.</p><p>Beyond your front door, lawn maintenance helps take yard work off your weekend, concierge service adds another layer of convenience, and the dog park gives four-legged companions a dedicated place to stretch out. Browse the <a href=\"/gallery\">photo gallery</a>, compare available <a href=\"/floor-plans\">three- and four-bedroom layouts</a>, or review the <a href=\"/pet-policy\">pet-friendly details</a> to see how Isabella Court’s features fit the way you live.</p>",
  "property_applynow_blurb": "<p><strong>Ready for brand-new rental-home living?</strong> Isabella Court pairs three- and four-bedroom space with polished finishes, smart-home ease, in-unit laundry, fenced-in backyards, and professional service that keeps things simple. Start your online application today and take the next step toward a refreshingly uncomplicated home in Leland.</p>",
  "property_contactus_blurb": "<p><strong>Have questions? We’re here to help.</strong> Reach out to Isabella Court’s leasing team for details on brand-new three- and four-bedroom rental homes, availability, or directions to the community in Leland—just minutes from Wilmington’s coastal energy.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Isabella Court?</strong> Start here for quick answers about brand-new rental-home living, leasing, community features, and day-to-day details in Leland. If you need anything else, the leasing team is happy to help—or schedule a tour and see the community for yourself.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits the way you live.</strong> Isabella Court keeps the choice refreshingly simple: a spacious three-bedroom Kershaw or an even more flexible four-bedroom Evans, each designed with the everyday advantages of a rental home in Leland. Open living areas, well-appointed kitchens with stainless steel appliances and granite countertops, luxury flooring, and in-unit laundry help your day move smoothly, while generous closets and fenced-in backyards add the space that matters beyond the main rooms. Compare current pricing and availability, check the floor plan cards below, then explore more <a href=\"/amenities\">interior features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how each layout feels in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details come into focus.</strong> Browse Isabella Court’s photo gallery for a closer look at bright, two-story rental homes in Leland, from open living areas with light wood-style flooring to kitchens framed by white cabinetry, granite counters, and stainless steel appliances. Picture morning light through French doors, everyday storage tucked into generous closets, and a fenced backyard that extends your living space outdoors.</p><p>As you move through the images, notice the clean finishes, neutral palette, and practical touches that make each home feel polished without feeling overdone. You can compare the Kershaw and Evans layouts on the <a href=\"/floor-plans\">floor plans</a> page, explore more <a href=\"/amenities\">home and community features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Isabella Court from every angle.</strong> Use the interactive map to browse available three- and four-bedroom rental homes, then see how close Leland shopping, dining, outdoor escapes, and Wilmington’s coastal energy can be. Start with <a href=\"/floor-plans\">available floor plans</a> or explore the <a href=\"/neighborhood\">neighborhood</a>.</p>",
  "property_pets_blurb": "<p><strong>Give paws a little more room.</strong> At Isabella Court, pet-friendly living feels less like a workaround and more like part of the design. Step from your rental home into a fenced-in backyard for fresh air between walks, head to the community dog park for a change of scenery, and leave the mowing to the lawn maintenance team. Inside, durable hardwood-style floors, air conditioning, and roomy closets help everyday pet gear, sunny naps, and cleanup feel easy. Review the policy details below, including required pet screening, then explore more <a href=\"/amenities\">pet-friendly features</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how life with your companion can settle in at Isabella Court.</p>",
  "property_referafriend_blurb": "<p><strong>Love the space and ease of Isabella Court?</strong> Share brand-new rental-home living, polished finishes, fenced-in backyards, and professionally managed convenience with a friend. Send an invite today and let them discover a refreshingly uncomplicated way to live minutes from Wilmington’s coastal energy.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, made simple.</strong><br>Log in to pay rent, submit maintenance requests, and manage your Isabella Court account with the streamlined service of a professionally managed community—so home stays polished, practical, and refreshingly uncomplicated.</p>",
  "property_reviews_blurb": "<p><strong>Hear what stands out at Isabella Court.</strong> Reviewers consistently praise the easy tour experience, responsive leasing support, and homes that feel thoughtfully designed from the first walkthrough.</p><p>You’ll see comments about self-guided tours that let you “unlock, explore, and imagine living here,” plus in-person guidance from Trever that made the leasing process feel clear and less stressful. Residents and visitors also highlight spacious layouts, modern kitchens, high ceilings, generous closet space, smart home features, and yards that make the homes easy to picture as your own. Read the reviews below to see why Isabella Court leaves such a strong impression.</p>",
  "property_created_at": "1786373754142",
  "property_scheduletour_blurb": "<p><strong>See brand-new rental-home living up close.</strong> Tour Isabella Court and experience spacious three- and four-bedroom layouts, polished finishes, fenced-in backyards, and professional service designed to keep life uncomplicated. Schedule your visit today and picture how coastal Carolina living comes together here.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will be in touch soon. In the meantime, picture brand-new rental-home living with spacious three- and four-bedroom layouts, high-end finishes, fenced-in backyards, and professional service that keeps coastal Carolina living polished, practical, and refreshingly uncomplicated.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through before you walk in.</strong> Isabella Court’s virtual tours let you move room by room through the two layouts currently available to explore: a spacious 3-bedroom, 2.5-bath home and a flexible 4-bedroom, 2.5-bath home.</p><p>Start in the open living areas, look closely at the kitchen finishes, check closet placement, and picture how the fenced-in backyard extends the home beyond the main rooms. From your screen, you can compare flow, storage, stairs, natural light, and everyday details that photos alone may not fully show. When one layout feels like the right fit, review current options on the <a href=\"/floor-plans\">floor plans</a> page or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Isabella Court in Leland in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Isabella Court",
  "property_seo_title_home": "Isabella Court |  Apartments in Leland, NC",
  "property_seo_description_home": "Discover luxury at Isabella Court in Leland, NC! Enjoy spacious layouts, modern amenities, a dog park, and smart-home tech. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Leland, NC Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Isabella Court in Leland, NC. Check out our unique three- and four-bedroom floor plans tailored for your lifestyle!",
  "property_seo_title_amenities": "Amenities | Leland, NC Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Isabella Court, Leland, NC! Enjoy luxury amenities, smart tech, fenced backyards, and spacious layouts. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Leland, NC",
  "property_seo_description_gallery": "Discover luxury at Isabella Court in Leland, NC. Explore our photo gallery of spacious layouts, smart-home features, and pet-friendly amenities!",
  "property_seo_title_virtualtours": "Virtual Tours | Isabella Court Apartments",
  "property_seo_description_virtualtours": "Experience comfort at Isabella Court in Leland, NC! Take a virtual tour of our spacious three and four-bedroom apartments designed for your ideal lifestyle.",
  "property_seo_title_interactivemap": "Interactive Map | Isabella Court Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Isabella Court in Leland, NC! Check out our interactive map for spacious 3- or 4-bedroom layouts and top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Leland, NC",
  "property_seo_description_neighborhood": "Uncover the charm of Leland, NC, near Isabella Court. Discover local favorites and hidden gems just steps from our vibrant three and four-bedroom homes.",
  "property_seo_title_contact": "Contact Us | Isabella Court",
  "property_seo_description_contact": "Reach out to Isabella Court in Leland, NC! Our friendly leasing team is ready to assist with questions about our spacious 3 & 4-bedroom floor plans.",
  "property_seo_title_faqs": "FAQs | Apartments in Leland, NC",
  "property_seo_description_faqs": "Unlock the answers to your questions at Isabella Court in Leland, NC! From spacious floor plans to luxury amenities, find everything you need in our FAQs.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Leland, NC",
  "property_seo_description_reviews": "At Isabella Court in Leland, NC, residents enjoy modern living with luxury amenities. Hear their stories and discover why they love calling it home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Leland, NC",
  "property_seo_description_applynow": "Unlock the charm of Isabella Court in Leland, NC! Enjoy spacious 3 & 4-bedroom layouts, dog parks, luxury finishes, and smart home tech. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Isabella Court",
  "property_seo_description_residentaccess": "Unlock your Isabella Court experience! Log in to your resident portal for seamless rent payments, maintenance requests, and community updates in Leland, NC.",
  "property_seo_title_referafriend": "Refer A Friend | Isabella Court",
  "property_seo_description_referafriend": "Great friends make the best neighbors! Refer a friend to Isabella Court in Leland, NC, and enjoy the perks of community living together. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Isabella Court",
  "property_seo_description_scheduletour": "Experience the charm of Isabella Court in Leland, NC. Schedule your tour today and see why our vibrant community is the perfect place to call home!",
  "property_seo_title_privacy": "Privacy Policy | Isabella Court",
  "property_seo_description_privacy": "At Isabella Court in Leland, NC, your privacy is a priority. Discover how we protect your information. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Isabella Court",
  "property_seo_description_accessibility": "At Isabella Court in Leland, NC, we prioritize digital access for everyone. Join us in fostering an inclusive community where everyone connects and thrives!",
  "property_seo_title_sitemap": "Sitemap | Isabella Court",
  "property_seo_description_sitemap": "Navigate your way through Isabella Court in Leland, NC! Check out our sitemap for a seamless guide to our vibrant community and amenities.",
  "property_seo_title_thankyou": "Thank You | Isabella Court",
  "property_seo_description_thankyou": "Thank you for reaching out to Isabella Court in Leland, NC! Our team will connect soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Leland, NC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793288506088",
  "amenities": [
    {
      "id": "ec_60d2f22b0217567efb6df45c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615741",
      "title": "Concierge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e94c0a7953a644182272175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615753",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d5c8fa7647f47112f616bea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615751",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_084e42aed05d35204cfaa611",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615752",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_295032467ec264b26a433a9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615749",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a19c8e2f59e45b60264e2af2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615750",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fc2393674d7753dac6a9bb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615745",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6529ab958a0b8d33dfaf5c2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615746",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6416854c8a530f88cfb1ca95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615747",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fef08d79696e04098a118b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615748",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6c2ff81c38d34099d51e141",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615743",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f214b3f5d49d58cf9c46d93b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "122615744",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_582774fd443e513329531782",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "123753680",
      "title": "Fenced-In Backyards",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_281dc950fa6d4973dd0e893d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-0eb8-77c2-9318-b66a5dadb8d4.webp",
      "image_media": {
        "alt_text": "Two-story houses with garages and manicured lawns under a cloudy sky.",
        "public_id": "019fec2e-0eb8-77c2-9318-b66a5dadb8d4",
        "storage_key": "property/6767906449167638/019fec2e-0eb8-77c2-9318-b66a5dadb8d4.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Community",
      "description": "Beautiful two-story homes featuring modern architecture, attached garages, and well-maintained landscaping, perfect for family living.",
      "link": "false",
      "alt_text": "Two houses with garages are shown in the image.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Row-of-Homes.jpg"
    },
    {
      "id": "ec_9200dc08b4e232d577543fcc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-1cc1-723e-baa7-efb7b89b40d2.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story house with a two-car garage.",
        "public_id": "019fec2e-1cc1-723e-baa7-efb7b89b40d2",
        "storage_key": "property/6767906449167638/019fec2e-1cc1-723e-baa7-efb7b89b40d2.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Charming exterior of a two-story home featuring a stone accent base and a spacious two-car garage.",
      "link": "false",
      "alt_text": "A house with a white garage door and purple window shutters.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kershaw-Exterior.jpg"
    },
    {
      "id": "ec_03496bb0899a19635702af19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-1c08-760d-bc41-f12eb97ce912.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island.",
        "public_id": "019fec2e-1c08-760d-bc41-f12eb97ce912",
        "storage_key": "property/6767906449167638/019fec2e-1c08-760d-bc41-f12eb97ce912.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, a center island with a sink, and ample cabinet space.",
      "link": "false",
      "alt_text": "A kitchen with a granite countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kershaw-Kitchen.jpg"
    },
    {
      "id": "ec_603b5dd645b6e592ae15408b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-1c6d-75fd-961f-8885e338c207.webp",
      "image_media": {
        "alt_text": "Spacious open-concept living room and kitchen area with light wood floors and a ceiling fan.",
        "public_id": "019fec2e-1c6d-75fd-961f-8885e338c207",
        "storage_key": "property/6767906449167638/019fec2e-1c6d-75fd-961f-8885e338c207.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy a bright and airy living space that seamlessly connects to a modern kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "A spacious room with wooden flooring and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kershaw-Kitchen-Living.jpg"
    },
    {
      "id": "ec_ff595fc92e17a8446a43ff2f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-1b3f-7455-ba4b-fc6b901d3415.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two windows and a ceiling fan.",
        "public_id": "019fec2e-1b3f-7455-ba4b-fc6b901d3415",
        "storage_key": "property/6767906449167638/019fec2e-1b3f-7455-ba4b-fc6b901d3415.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, large windows with blinds, and wood-look flooring, ready for your personal touch.",
      "link": "false",
      "alt_text": "A room with a ceiling fan and two windows with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kershaw-Primary-Bedroom.jpg"
    },
    {
      "id": "ec_1a7902b830c8069b23fbf295",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-1e71-747d-a99e-4eff27ece66b.webp",
      "image_media": {
        "alt_text": "Exterior front view of a two-story house with a brick and siding facade, a covered porch, and an attached garage.",
        "public_id": "019fec2e-1e71-747d-a99e-4eff27ece66b",
        "storage_key": "property/6767906449167638/019fec2e-1e71-747d-a99e-4eff27ece66b.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Charming two-story home featuring a welcoming covered porch, attractive brick and siding exterior, and a convenient attached garage. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "A two-story house with a garage door and a driveway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Evans-Exterior.jpg"
    },
    {
      "id": "ec_5bfe8f2189221914edd6f284",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2930-751d-a9c2-5c1e38146303.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops",
        "public_id": "019fec2e-2930-751d-a9c2-5c1e38146303",
        "storage_key": "property/6767906449167638/019fec2e-2930-751d-a9c2-5c1e38146303.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, ample cabinet space, and a convenient layout. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Evans-Kitchen.jpg"
    },
    {
      "id": "ec_a159136e9cd2d1b79cc0e18a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2af5-74fd-ae3b-de9fed45c004.webp",
      "image_media": {
        "alt_text": "Open concept living area with stairs leading upstairs and a modern kitchen with stainless steel appliances.",
        "public_id": "019fec2e-2af5-74fd-ae3b-de9fed45c004",
        "storage_key": "property/6767906449167638/019fec2e-2af5-74fd-ae3b-de9fed45c004.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring modern finishes, a convenient kitchen, and stairs to the upper level.",
      "link": "false",
      "alt_text": "A spacious room with wooden floors and a staircase leading to the upper level.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Evans-Kitchen-Living.jpg"
    },
    {
      "id": "ec_029e144dc8d0215d923989e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2c2e-7092-b34d-a7e0a7f16e2d.webp",
      "image_media": {
        "alt_text": "Bright bathroom with white vanity, sink, toilet, and closet with shelves.",
        "public_id": "019fec2e-2c2e-7092-b34d-a7e0a7f16e2d",
        "storage_key": "property/6767906449167638/019fec2e-2c2e-7092-b34d-a7e0a7f16e2d.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern vanity with a white countertop and sink, a toilet, and a walk-in closet with ample shelving.",
      "link": "false",
      "alt_text": "A white toilet sits in a bathroom with a white sink and a white cabinet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Evans-Primary-Bathroom.jpg"
    },
    {
      "id": "ec_9eb4997cbf0841b6d5893cb0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2ce5-779f-989b-162f4ab53893.webp",
      "image_media": {
        "alt_text": "Aerial view of three houses with driveways and manicured lawns.",
        "public_id": "019fec2e-2ce5-779f-989b-162f4ab53893",
        "storage_key": "property/6767906449167638/019fec2e-2ce5-779f-989b-162f4ab53893.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Community",
      "description": "Discover these charming homes from an aerial perspective, showcasing their driveways, green spaces, and architectural design. Perfect for visualizing community layout and property appeal.",
      "link": "false",
      "alt_text": "Three houses with grey roofs and white columns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Aerial-Homes-TopView.jpg"
    },
    {
      "id": "ec_c0f71601106d1be04658d9db",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2f8c-7095-a794-9682f70d2c17.webp",
      "image_media": {
        "alt_text": "Exterior view of two new construction townhomes with attached garages.",
        "public_id": "019fec2e-2f8c-7095-a794-9682f70d2c17",
        "storage_key": "property/6767906449167638/019fec2e-2f8c-7095-a794-9682f70d2c17.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Community",
      "description": "Beautiful exterior view of two new townhomes, showcasing modern design and curb appeal.",
      "link": "false",
      "alt_text": "Two houses with garages are shown in the image.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Row-of-Homes(1).jpg"
    },
    {
      "id": "ec_3fb01260cf00b1e6567d2f5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-36f6-72be-98b9-887d4b81febe.webp",
      "image_media": {
        "alt_text": "Exterior view of two modern townhouses with garages under a bright blue sky with clouds.",
        "public_id": "019fec2e-36f6-72be-98b9-887d4b81febe",
        "storage_key": "property/6767906449167638/019fec2e-36f6-72be-98b9-887d4b81febe.webp",
        "width": 1981,
        "height": 1394
      },
      "title": "Apartment",
      "description": "View the exteriors of these beautiful townhomes, featuring spacious layouts and modern designs. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "A two-story house with a garage on the ground floor and a living area on the upper floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court---Row-of-Homes-4.jpg"
    },
    {
      "id": "ec_91d1f00b6620f883fa8a329d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-3a79-7526-be6b-c882ec7bbb2f.webp",
      "image_media": {
        "alt_text": "Two-story townhomes with white siding, black shutters, and attached garages.",
        "public_id": "019fec2e-3a79-7526-be6b-c882ec7bbb2f",
        "storage_key": "property/6767906449167638/019fec2e-3a79-7526-be6b-c882ec7bbb2f.webp",
        "width": 1891,
        "height": 1330
      },
      "title": "Community",
      "description": "Discover comfortable living in these charming two-story townhomes, featuring modern white siding, classic black shutters, and convenient attached garages. Your ideal home awaits.",
      "link": "false",
      "alt_text": "Two houses with garages are situated in a sunny suburban area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court---Row-of-Homes-5.jpg"
    },
    {
      "id": "ec_42835fca7b83b792a9382ada",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-3bbc-725f-82a6-4f9c377f4ec0.webp",
      "image_media": {
        "alt_text": "Two-story houses with garages and manicured lawns under a bright blue sky.",
        "public_id": "019fec2e-3bbc-725f-82a6-4f9c377f4ec0",
        "storage_key": "property/6767906449167638/019fec2e-3bbc-725f-82a6-4f9c377f4ec0.webp",
        "width": 1805,
        "height": 1269
      },
      "title": "Community",
      "description": "Exterior view of two modern two-story houses, featuring attached garages, clean lines, and a bright blue sky overhead.",
      "link": "false",
      "alt_text": "Two houses with garages are situated in a suburban neighborhood.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court---Row-of-Homes-6.jpg"
    },
    {
      "id": "ec_f9d11a2203c38a0fb3d3ac06",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-40c9-7038-82c3-ce247128ef68.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and green spaces.",
        "public_id": "019fec2e-40c9-7038-82c3-ce247128ef68",
        "storage_key": "property/6767906449167638/019fec2e-40c9-7038-82c3-ce247128ef68.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover this charming neighborhood with beautifully designed homes, ample green spaces, and a serene pond. An ideal setting for comfortable living.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential area with houses and a pond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella%20Court%20aerial.jpg"
    },
    {
      "id": "ec_af2c183e03a1f82cc7786f19",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-3e73-70bf-a627-3b534823def8.webp",
      "image_media": {
        "alt_text": "Empty living room with natural light from windows and a door.",
        "public_id": "019fec2e-3e73-70bf-a627-3b534823def8",
        "storage_key": "property/6767906449167638/019fec2e-3e73-70bf-a627-3b534823def8.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Bright and airy living room space, perfect for your personal touch. Features large windows and a door for natural light and easy access.",
      "link": "false",
      "alt_text": "Empty living room with natural light from windows and a door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Living-Room%201(1).jpg"
    },
    {
      "id": "ec_c22d925615d66036b7777607",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-4c8d-7113-bf25-0259a58375fc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large island.",
        "public_id": "019fec2e-4c8d-7113-bf25-0259a58375fc",
        "storage_key": "property/6767906449167638/019fec2e-4c8d-7113-bf25-0259a58375fc.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring white cabinetry, granite countertops, a full suite of stainless steel appliances, and a central island perfect for meal prep and casual dining.",
      "link": "false",
      "alt_text": "A modern kitchen with a granite countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Kitchen%201(1).jpg"
    },
    {
      "id": "ec_ffb88c27e6362e63f99bc0f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-4cd7-73ec-9276-3276df946a1b.webp",
      "image_media": {
        "alt_text": "Modern glass-door shower with seating and a window with blinds.",
        "public_id": "019fec2e-4cd7-73ec-9276-3276df946a1b",
        "storage_key": "property/6767906449167638/019fec2e-4cd7-73ec-9276-3276df946a1b.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Step into a clean and bright bathroom featuring a spacious shower with built-in seating and a large window for natural light.",
      "link": "false",
      "alt_text": "Modern glass-door shower with seating and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Primary-Bathroom.jpg"
    },
    {
      "id": "ec_bf9058fd8543aaa85fcfabef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-501d-725d-b1be-1b095ce3c9f0.webp",
      "image_media": {
        "alt_text": "Interior view of a hallway and room with a window and wood floors",
        "public_id": "019fec2e-501d-725d-b1be-1b095ce3c9f0",
        "storage_key": "property/6767906449167638/019fec2e-501d-725d-b1be-1b095ce3c9f0.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious and bright interior with wood flooring, a hallway leading to a room with a window, and neutral wall colors.",
      "link": "false",
      "alt_text": "Interior view of a hallway and room with a window and wood floors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Flex-Space%202(1).jpg"
    },
    {
      "id": "ec_c9c70cb4fe703a7ccaede01a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-53a6-7748-a853-520efab70691.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and hardwood floors.",
        "public_id": "019fec2e-53a6-7748-a853-520efab70691",
        "storage_key": "property/6767906449167638/019fec2e-53a6-7748-a853-520efab70691.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, a large island with a sink, stainless steel appliances, and elegant hardwood floors.",
      "link": "false",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and hardwood floors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Kitchen%202.jpg"
    },
    {
      "id": "ec_43f790a120d47eb885664ac2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-5bae-743a-aeb7-34b5ab74797e.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood floors and ceiling fan",
        "public_id": "019fec2e-5bae-743a-aeb7-34b5ab74797e",
        "storage_key": "property/6767906449167638/019fec2e-5bae-743a-aeb7-34b5ab74797e.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious bedroom with natural light, wood flooring, and a ceiling fan. Perfect for creating your own sanctuary.",
      "link": "false",
      "alt_text": "Empty bedroom with wood floors and ceiling fan",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Living-Room(1).jpg"
    },
    {
      "id": "ec_9b55a941b8fd279f04876d6f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-652a-716d-94a6-fdb7c3bf84ae.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and wood flooring.",
        "public_id": "019fec2e-652a-716d-94a6-fdb7c3bf84ae",
        "storage_key": "property/6767906449167638/019fec2e-652a-716d-94a6-fdb7c3bf84ae.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving to organize your belongings. Features modern wood flooring for a clean look.",
      "link": "false",
      "alt_text": "Empty room with white walls and wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Closet(1).jpg"
    },
    {
      "id": "ec_2e71ad3a8b760772eac7c42b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-6659-754e-a6f0-4d5e7bc591f3.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer",
        "public_id": "019fec2e-6659-754e-a6f0-4d5e7bc591f3",
        "storage_key": "property/6767906449167638/019fec2e-6659-754e-a6f0-4d5e7bc591f3.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of an in-unit washer and dryer for all your laundry needs.",
      "link": "false",
      "alt_text": "Two white dryers are sitting in a room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Laundry(1).jpg"
    },
    {
      "id": "ec_95c782fdc4d1b3c323330772",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-6908-74ca-81d3-f4ad561d7aab.webp",
      "image_media": {
        "alt_text": "Spacious living area with light wood flooring and large windows.",
        "public_id": "019fec2e-6908-74ca-81d3-f4ad561d7aab",
        "storage_key": "property/6767906449167638/019fec2e-6908-74ca-81d3-f4ad561d7aab.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Experience the open-concept living in this spacious apartment, featuring abundant natural light and elegant wood-look flooring.",
      "link": "false",
      "alt_text": "Spacious living area with light wood flooring and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Living-Space%201(1).jpg"
    },
    {
      "id": "ec_61178e05c7cd13d56777a16b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-6b4d-71d1-9a24-5c5d49436675.webp",
      "image_media": {
        "alt_text": "Empty room with light wood floors and a window with blinds.",
        "public_id": "019fec2e-6b4d-71d1-9a24-5c5d49436675",
        "storage_key": "property/6767906449167638/019fec2e-6b4d-71d1-9a24-5c5d49436675.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "An empty room featuring light wood flooring, neutral walls, and a window with blinds offering natural light.",
      "link": "false",
      "alt_text": "A room with wooden flooring and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Bedroom(1).jpg"
    },
    {
      "id": "ec_1e36998128ddbc13d8b42f74",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-7133-767d-8dd7-f3dcc2014618.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with a large island and stainless steel sink.",
        "public_id": "019fec2e-7133-767d-8dd7-f3dcc2014618",
        "storage_key": "property/6767906449167638/019fec2e-7133-767d-8dd7-f3dcc2014618.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept living space with beautiful hardwood floors, a modern kitchen island, and ample natural light.",
      "link": "false",
      "alt_text": "Spacious living room and kitchen area with a large island and stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Living-Space(1).jpg"
    },
    {
      "id": "ec_383bdcc34c01bdb14641b6c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-81f5-777b-acc1-b8b92131c284.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with stainless steel appliances, island, and hardwood floors.",
        "public_id": "019fec2e-81f5-777b-acc1-b8b92131c284",
        "storage_key": "property/6767906449167638/019fec2e-81f5-777b-acc1-b8b92131c284.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious and open-concept living area seamlessly connected to a modern kitchen, featuring stainless steel appliances, a convenient island, and beautiful hardwood floors.",
      "link": "false",
      "alt_text": "A spacious kitchen with wooden floors and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Kitchen%204(1).jpg"
    },
    {
      "id": "ec_197b6b14257a83c9ac50972d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-7efc-7363-ad7f-161b240947d9.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a window and a closed door.",
        "public_id": "019fec2e-7efc-7363-ad7f-161b240947d9",
        "storage_key": "property/6767906449167638/019fec2e-7efc-7363-ad7f-161b240947d9.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "This unfurnished bedroom features a large window and a closet, ready for you to make it your own.",
      "link": "false",
      "alt_text": "Empty bedroom with a window and a closed door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Bedroom%202(1).jpg"
    },
    {
      "id": "ec_612edc673bc4322a22799c8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-8453-7189-a47a-55820c877c9f.webp",
      "image_media": {
        "alt_text": "Empty living room with light wood flooring and two windows with blinds.",
        "public_id": "019fec2e-8453-7189-a47a-55820c877c9f",
        "storage_key": "property/6767906449167638/019fec2e-8453-7189-a47a-55820c877c9f.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious and bright living area featuring light wood-look flooring and large windows that provide ample natural light.",
      "link": "false",
      "alt_text": "A room with wooden flooring and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Flex-Space(1).jpg"
    },
    {
      "id": "ec_21b427db085096708c0a11fd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-8bd5-72b3-8421-e8f972858b12.webp",
      "image_media": {
        "alt_text": "Empty bedroom with hardwood floors and a large window.",
        "public_id": "019fec2e-8bd5-72b3-8421-e8f972858b12",
        "storage_key": "property/6767906449167638/019fec2e-8bd5-72b3-8421-e8f972858b12.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A bright and airy empty bedroom featuring beautiful hardwood floors and a large window, ready for you to make it your own.",
      "link": "false",
      "alt_text": "A room with wooden flooring and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Bedroom%203(1).jpg"
    },
    {
      "id": "ec_c90c533f0790c08035729c1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-90e8-76e8-b5b4-774b2354b174.webp",
      "image_media": {
        "alt_text": "Empty room with light gray walls and wood plank flooring.",
        "public_id": "019fec2e-90e8-76e8-b5b4-774b2354b174",
        "storage_key": "property/6767906449167638/019fec2e-90e8-76e8-b5b4-774b2354b174.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "An empty room featuring light gray walls, wood plank flooring, and a doorway leading to another room.",
      "link": "false",
      "alt_text": "A room with wooden flooring and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Bedroom%204.jpg"
    },
    {
      "id": "ec_259f38c4c9d57caae84807b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-98be-721a-9b28-f70fe7b06665.webp",
      "image_media": {
        "alt_text": "Bright and airy living area with wood-look floors and large windows.",
        "public_id": "019fec2e-98be-721a-9b28-f70fe7b06665",
        "storage_key": "property/6767906449167638/019fec2e-98be-721a-9b28-f70fe7b06665.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living area featuring modern wood-look flooring and abundant natural light from large windows, creating an inviting atmosphere.",
      "link": "false",
      "alt_text": "A room with wooden floors and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Living-Room%203(1).jpg"
    },
    {
      "id": "ec_bce6a4cb87d84c48dc2e10af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-9cd1-7239-8dc3-576d043d18f9.webp",
      "image_media": {
        "alt_text": "Interior hallway with two doors and a visible room through an open doorway.",
        "public_id": "019fec2e-9cd1-7239-8dc3-576d043d18f9",
        "storage_key": "property/6767906449167638/019fec2e-9cd1-7239-8dc3-576d043d18f9.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Walk through the interior of this apartment, featuring a hallway with two closed doors and an open doorway leading to a bright room.",
      "link": "false",
      "alt_text": "A room with wooden floors and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Hallway.jpg"
    },
    {
      "id": "ec_e2940fc84a017e505227e550",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-9b5b-7588-af84-f7ab2bd9ae10.webp",
      "image_media": {
        "alt_text": "Hallway with wood floors and white walls",
        "public_id": "019fec2e-9b5b-7588-af84-f7ab2bd9ae10",
        "storage_key": "property/6767906449167638/019fec2e-9b5b-7588-af84-f7ab2bd9ae10.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Interior hallway with light wood flooring and white walls. Features include a railing, attic access, and light fixtures.",
      "link": "false",
      "alt_text": "A room with wooden flooring and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Flex-Space%201.jpg"
    },
    {
      "id": "ec_1d19c7db83961b57d880a281",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-a15b-70de-a22f-39700a8119e7.webp",
      "image_media": {
        "alt_text": "Empty closet with wire shelving and a light switch.",
        "public_id": "019fec2e-a15b-70de-a22f-39700a8119e7",
        "storage_key": "property/6767906449167638/019fec2e-a15b-70de-a22f-39700a8119e7.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious closet with ample wire shelving for storage, featuring wood-look flooring and a convenient light switch.",
      "link": "false",
      "alt_text": "A room with a light switch and wooden flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Closet%201.jpg"
    },
    {
      "id": "ec_0d3db5231d2559dd60c2e884",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-a263-73ab-bc23-cc1335560037.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a doorway leading to a closet.",
        "public_id": "019fec2e-a263-73ab-bc23-cc1335560037",
        "storage_key": "property/6767906449167638/019fec2e-a263-73ab-bc23-cc1335560037.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "An empty bedroom featuring light-colored walls and wood-look flooring. A door opens into a walk-in closet with built-in shelving.",
      "link": "false",
      "alt_text": "A room with wooden flooring and a white door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Bedroom%201.jpg"
    },
    {
      "id": "ec_f1f90b8146f13e2807a77f6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-aabb-7665-a45d-38db10d5cc7c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and a large island.",
        "public_id": "019fec2e-aabb-7665-a45d-38db10d5cc7c",
        "storage_key": "property/6767906449167638/019fec2e-aabb-7665-a45d-38db10d5cc7c.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Discover the perfect blend of style and functionality in this modern kitchen, featuring sleek white cabinetry, elegant granite countertops, and premium stainless steel appliances.",
      "link": "false",
      "alt_text": "A kitchen with white cabinets and a white island with a refrigerator and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Kitchen(1).jpg"
    },
    {
      "id": "ec_0a70388920dcc180f1189728",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-b098-7473-a155-72df8c17e923.webp",
      "image_media": {
        "alt_text": "White bathtub and toilet in a clean bathroom",
        "public_id": "019fec2e-b098-7473-a155-72df8c17e923",
        "storage_key": "property/6767906449167638/019fec2e-b098-7473-a155-72df8c17e923.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Modern white bathtub and toilet, perfect for a refreshing soak after a long day.",
      "link": "false",
      "alt_text": "A white toilet and sink in a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Bathroom(1).jpg"
    },
    {
      "id": "ec_0e324908b6e62723fa4a7fcc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-b35d-73dc-880a-27d93a46c4a3.webp",
      "image_media": {
        "alt_text": "White toilet with a brushed nickel toilet paper holder and a light switch on a light grey wall.",
        "public_id": "019fec2e-b35d-73dc-880a-27d93a46c4a3",
        "storage_key": "property/6767906449167638/019fec2e-b35d-73dc-880a-27d93a46c4a3.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a white toilet, brushed nickel fixtures, and light grey walls.",
      "link": "false",
      "alt_text": "A white toilet in a small bathroom with a wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Bathroom%201.jpg"
    },
    {
      "id": "ec_4ca4d75f017ada5f57c19262",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-b538-76b9-b6c4-0425ef09c411.webp",
      "image_media": {
        "alt_text": "Hallway with a pedestal sink and toilet, leading to stairs.",
        "public_id": "019fec2e-b538-76b9-b6c4-0425ef09c411",
        "storage_key": "property/6767906449167638/019fec2e-b538-76b9-b6c4-0425ef09c411.webp",
        "width": 3034,
        "height": 1707
      },
      "title": "Apartment",
      "description": "A bright hallway featuring a pedestal sink and toilet on the left, with doors on either side. The hallway leads to a staircase, offering a glimpse into the upper level of the home.",
      "link": "false",
      "alt_text": "A white sink with a round mirror above it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Kershaw-Entry(1).jpg"
    },
    {
      "id": "ec_83fcfec1ec3a6aa09ee770a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-bb62-75b8-947c-ae0daf6730a2.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and walk-in closet.",
        "public_id": "019fec2e-bb62-75b8-947c-ae0daf6730a2",
        "storage_key": "property/6767906449167638/019fec2e-bb62-75b8-947c-ae0daf6730a2.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a spacious vanity, a comfortable toilet, and a convenient walk-in closet with shelving.",
      "link": "false",
      "alt_text": "Bathroom with vanity, toilet, and walk-in closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Primary-Bathroom(1).jpg"
    },
    {
      "id": "ec_3dd764c7bb1c838d2c305063",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-c208-75c3-8fb9-1d3daa94ad42.webp",
      "image_media": {
        "alt_text": "Empty bedroom with light wood flooring and two windows.",
        "public_id": "019fec2e-c208-75c3-8fb9-1d3daa94ad42",
        "storage_key": "property/6767906449167638/019fec2e-c208-75c3-8fb9-1d3daa94ad42.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom with large windows, perfect for a restful retreat. Features modern light wood flooring.",
      "link": "false",
      "alt_text": "Empty bedroom with light wood flooring and two windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Primary-Bedroom(1).jpg"
    },
    {
      "id": "ec_9070c68944650ddc4e5e5f2c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-c8e9-72fa-abab-91cb227fa76d.webp",
      "image_media": {
        "alt_text": "Empty living room with wood floors and two windows.",
        "public_id": "019fec2e-c8e9-72fa-abab-91cb227fa76d",
        "storage_key": "property/6767906449167638/019fec2e-c8e9-72fa-abab-91cb227fa76d.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious living area with abundant natural light from two large windows, featuring beautiful wood-look flooring.",
      "link": "false",
      "alt_text": "Empty living room with wood floors and two windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Living-Room%202.jpg"
    },
    {
      "id": "ec_1edd45b1e931c4d2b0670877",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-c844-7599-af07-5b5107d5e94c.webp",
      "image_media": {
        "alt_text": "Living room with wood floors and double glass doors.",
        "public_id": "019fec2e-c844-7599-af07-5b5107d5e94c",
        "storage_key": "property/6767906449167638/019fec2e-c844-7599-af07-5b5107d5e94c.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious living room featuring wood-look flooring and access to the outdoors through double glass doors.",
      "link": "false",
      "alt_text": "Living room with wood floors and double glass doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Living-Room%203.jpg"
    },
    {
      "id": "ec_3eb74b5f92b082c21cde1665",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-cf0b-7262-9572-8888d2ef7733.webp",
      "image_media": {
        "alt_text": "Empty bedroom with white door and two windows.",
        "public_id": "019fec2e-cf0b-7262-9572-8888d2ef7733",
        "storage_key": "property/6767906449167638/019fec2e-cf0b-7262-9572-8888d2ef7733.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious and bright bedroom with natural light from two large windows and a clean, modern aesthetic.",
      "link": "false",
      "alt_text": "Empty bedroom with white door and two windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Primary-Bedroom%201(1).jpg"
    },
    {
      "id": "ec_898cbd4d0ab967963c70758e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-d20c-749f-8827-a3a41d1edc60.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
        "public_id": "019fec2e-d20c-749f-8827-a3a41d1edc60",
        "storage_key": "property/6767906449167638/019fec2e-d20c-749f-8827-a3a41d1edc60.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Discover the heart of your home in this beautifully appointed kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and generous storage.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Kitchen%202.jpg"
    },
    {
      "id": "ec_10d3020bf107206a13e5630f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-d622-71e9-bd16-aa59c22cd8e1.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room.",
        "public_id": "019fec2e-d622-71e9-bd16-aa59c22cd8e1",
        "storage_key": "property/6767906449167638/019fec2e-d622-71e9-bd16-aa59c22cd8e1.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "Washer and dryer in a laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Laundry(1).jpg"
    },
    {
      "id": "ec_152ee1c1b735bf62943c9c65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-e0d9-7491-af76-8588eaf9cdb6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and granite countertops.",
        "public_id": "019fec2e-e0d9-7491-af76-8588eaf9cdb6",
        "storage_key": "property/6767906449167638/019fec2e-e0d9-7491-af76-8588eaf9cdb6.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Step into this beautiful and functional kitchen, featuring sleek stainless steel appliances, ample white cabinetry, and elegant granite countertops for a premium look and feel.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinetry, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Kitchen(1).jpg"
    },
    {
      "id": "ec_4c5a42bec33f9bcc2ae40298",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-e220-77db-83ab-54946d848017.webp",
      "image_media": {
        "alt_text": "Empty bedroom with blinds on the window and French doors leading outside.",
        "public_id": "019fec2e-e220-77db-83ab-54946d848017",
        "storage_key": "property/6767906449167638/019fec2e-e220-77db-83ab-54946d848017.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious bedroom with wood-style flooring and large French doors that offer ample natural light.",
      "link": "false",
      "alt_text": "Empty bedroom with blinds on the window and French doors leading outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Living-Room%201(1).jpg"
    },
    {
      "id": "ec_2e6bf95925bc541cb7a5b42e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-e65e-76bf-a170-ec8148b00dbe.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with stairs",
        "public_id": "019fec2e-e65e-76bf-a170-ec8148b00dbe",
        "storage_key": "property/6767906449167638/019fec2e-e65e-76bf-a170-ec8148b00dbe.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living room adjacent to a modern kitchen with stainless steel appliances and a breakfast bar. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area with stairs",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Living-Room%204(1).jpg"
    },
    {
      "id": "ec_3d5993859b23cedc0330f671",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-f0e0-764f-b97a-d4f0267349c2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, white cabinets, and granite countertops.",
        "public_id": "019fec2e-f0e0-764f-b97a-d4f0267349c2",
        "storage_key": "property/6767906449167638/019fec2e-f0e0-764f-b97a-d4f0267349c2.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring a spacious granite island, stainless steel appliances, and ample cabinet storage.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel refrigerator, white cabinets, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Kitchen%201(1).jpg"
    },
    {
      "id": "ec_0660115cdaf42c16e3c99c1b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-ef56-7566-9d4a-88aec9568ede.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment bedroom with light wood floors and white walls.",
        "public_id": "019fec2e-ef56-7566-9d4a-88aec9568ede",
        "storage_key": "property/6767906449167638/019fec2e-ef56-7566-9d4a-88aec9568ede.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Step into comfort in this spacious apartment bedroom, featuring beautiful light wood flooring and clean white walls. Perfect for creating your personal oasis.",
      "link": "false",
      "alt_text": "Interior view of an empty apartment bedroom with light wood floors and white walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bedroom(1).jpg"
    },
    {
      "id": "ec_cdcb2f414b8ad8feef4211dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-08bb-73c2-9495-de793d7a3939.webp",
      "image_media": {
        "alt_text": "Interior of a bedroom with light wood floors and white walls, featuring double closet doors and a window.",
        "public_id": "019fec2f-08bb-73c2-9495-de793d7a3939",
        "storage_key": "property/6767906449167638/019fec2f-08bb-73c2-9495-de793d7a3939.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring modern light wood flooring, ample closet space with double doors, and a large window for natural light.",
      "link": "false",
      "alt_text": "A room with a white door and a white cabinet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Flex-Space(1).jpg"
    },
    {
      "id": "ec_c4069883533bd837cc850c1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-0ab0-75d8-abd5-a78e5c103335.webp",
      "image_media": {
        "alt_text": "Empty bedroom with two windows and wood flooring.",
        "public_id": "019fec2f-0ab0-75d8-abd5-a78e5c103335",
        "storage_key": "property/6767906449167638/019fec2f-0ab0-75d8-abd5-a78e5c103335.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious and bright bedroom featuring large windows with blinds and elegant wood flooring, offering a blank canvas for your personal style.",
      "link": "false",
      "alt_text": "Empty bedroom with two windows and wood flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bedroom%203(1).jpg"
    },
    {
      "id": "ec_f74e29b9aa252c9f8bd8f297",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-0a56-745d-84e3-47b04b98f7cd.webp",
      "image_media": {
        "alt_text": "Empty living room with hardwood floors and French doors leading outside.",
        "public_id": "019fec2f-0a56-745d-84e3-47b04b98f7cd",
        "storage_key": "property/6767906449167638/019fec2f-0a56-745d-84e3-47b04b98f7cd.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious living area featuring elegant hardwood floors and double French doors, creating a bright and airy atmosphere.",
      "link": "false",
      "alt_text": "Empty living room with hardwood floors and French doors leading outside.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Living-Room(1).jpg"
    },
    {
      "id": "ec_0ea0957268b79a6ae1d25baf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-1127-75e7-914d-c4c15d698027.webp",
      "image_media": {
        "alt_text": "Bedroom with blinds on window and wood-style flooring.",
        "public_id": "019fec2f-1127-75e7-914d-c4c15d698027",
        "storage_key": "property/6767906449167638/019fec2f-1127-75e7-914d-c4c15d698027.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "This bedroom features large windows with blinds and beautiful wood-style flooring, offering a bright and airy feel.",
      "link": "false",
      "alt_text": "Bedroom with blinds on window and wood-style flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bedroom%204.jpg"
    },
    {
      "id": "ec_0ca64121dccb9ab6c1c5f946",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-1abd-731f-9c39-0a391df45261.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, large mirror, and shower.",
        "public_id": "019fec2f-1abd-731f-9c39-0a391df45261",
        "storage_key": "property/6767906449167638/019fec2f-1abd-731f-9c39-0a391df45261.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with dual sinks and a large mirror. The bathroom also includes a separate shower and ample storage space.",
      "link": "false",
      "alt_text": "Bathroom with double vanity, large mirror, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bathroom%202.jpg"
    },
    {
      "id": "ec_f73aaa59ab8dc90485f85180",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-2033-7486-9965-1f20fb68225a.webp",
      "image_media": {
        "alt_text": "Empty bedroom with hardwood floors and blinds on windows.",
        "public_id": "019fec2f-2033-7486-9965-1f20fb68225a",
        "storage_key": "property/6767906449167638/019fec2f-2033-7486-9965-1f20fb68225a.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Spacious bedroom with large windows, hardwood flooring, and ample natural light. Perfect for personalization.",
      "link": "false",
      "alt_text": "Empty bedroom with hardwood floors and blinds on windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bedroom%201.jpg"
    },
    {
      "id": "ec_980e4d6cfa1cb3b539ea53e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-2014-772b-b4c1-2cac4f468ce1.webp",
      "image_media": {
        "alt_text": "View of a hallway leading to a bathroom with a pedestal sink, mirror, and towel ring.",
        "public_id": "019fec2f-2014-772b-b4c1-2cac4f468ce1",
        "storage_key": "property/6767906449167638/019fec2f-2014-772b-b4c1-2cac4f468ce1.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A stylish and functional bathroom featuring a pedestal sink, an oval mirror, and a towel ring, perfect for guest use or as part of a modern apartment layout.",
      "link": "false",
      "alt_text": "A bathroom with a sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bathroom%201.jpg"
    },
    {
      "id": "ec_81377601613b8690102ab232",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-22ba-74fc-906c-7f8a0ee36e87.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019fec2f-22ba-74fc-906c-7f8a0ee36e87",
        "storage_key": "property/6767906449167638/019fec2f-22ba-74fc-906c-7f8a0ee36e87.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Experience the modern charm of this fully equipped kitchen, featuring sleek white cabinetry, elegant granite countertops, and top-of-the-line stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Kitchen%204.jpg"
    },
    {
      "id": "ec_c3df6f768a7772dbd70ba222",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-29f1-71a2-ae8b-c3920c5a4ea9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and bathtub/shower combo.",
        "public_id": "019fec2f-29f1-71a2-ae8b-c3920c5a4ea9",
        "storage_key": "property/6767906449167638/019fec2f-29f1-71a2-ae8b-c3920c5a4ea9.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "Step into this sleek bathroom featuring a spacious vanity with a quartz countertop, a modern toilet, and a clean bathtub and shower combination, all complemented by warm wood-look flooring.",
      "link": "false",
      "alt_text": "Modern bathroom with vanity, toilet, and bathtub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bathroom(1).jpg"
    },
    {
      "id": "ec_e0de8b8cff95cf2f4fbba813",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-35d7-7326-b7d8-0bc3af7543f0.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood floors and white doors.",
        "public_id": "019fec2f-35d7-7326-b7d8-0bc3af7543f0",
        "storage_key": "property/6767906449167638/019fec2f-35d7-7326-b7d8-0bc3af7543f0.webp",
        "width": 1920,
        "height": 1080
      },
      "title": "Apartment",
      "description": "A spacious and bright empty bedroom featuring elegant wood flooring and clean white doors, ready for your personal touch.",
      "link": "false",
      "alt_text": "Empty bedroom with wood floors and white doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Bedroom%202(1).jpg"
    },
    {
      "id": "ec_f7b1caf9bf160c850a23db28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-3a8c-744c-a966-fbd33fe49eed.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019fec2f-3a8c-744c-a966-fbd33fe49eed",
        "storage_key": "property/6767906449167638/019fec2f-3a8c-744c-a966-fbd33fe49eed.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring granite countertops, stainless steel appliances, and plenty of cabinet space for all your culinary needs.",
      "link": "false",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Kitchen%203(1).jpg"
    },
    {
      "id": "ec_939e934ebd6122cfe9b8ee26",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-3670-737c-8e8d-a0c064cbd162.webp",
      "image_media": {
        "alt_text": "Hallway leading to living area and kitchen",
        "public_id": "019fec2f-3670-737c-8e8d-a0c064cbd162",
        "storage_key": "property/6767906449167638/019fec2f-3670-737c-8e8d-a0c064cbd162.webp",
        "width": 3034,
        "height": 1707
      },
      "title": "Apartment",
      "description": "View down a bright hallway towards the open living area and kitchen. Features wood flooring and interior doors.",
      "link": "false",
      "alt_text": "Hallway leading to living area and kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court-Evans-Entry.jpg"
    },
    {
      "id": "ec_75d4a90aa0563866771122ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2ce5-779f-989b-162f4ab53893.webp",
      "image_media": {
        "alt_text": "Aerial view of three houses with driveways and manicured lawns.",
        "public_id": "019fec2e-2ce5-779f-989b-162f4ab53893",
        "storage_key": "property/6767906449167638/019fec2e-2ce5-779f-989b-162f4ab53893.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Community",
      "description": "Discover these charming homes from an aerial perspective, showcasing their driveways, green spaces, and architectural design. Perfect for visualizing community layout and property appeal.",
      "link": "false",
      "alt_text": "Three houses with grey roofs and white columns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Aerial-Homes-TopView.jpg"
    },
    {
      "id": "ec_887ddee62b73c9428ba9d66b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-2f8c-7095-a794-9682f70d2c17.webp",
      "image_media": {
        "alt_text": "Exterior view of two new construction townhomes with attached garages.",
        "public_id": "019fec2e-2f8c-7095-a794-9682f70d2c17",
        "storage_key": "property/6767906449167638/019fec2e-2f8c-7095-a794-9682f70d2c17.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Community",
      "description": "Beautiful exterior view of two new townhomes, showcasing modern design and curb appeal.",
      "link": "false",
      "alt_text": "Two houses with garages are shown in the image.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Row-of-Homes(1).jpg"
    },
    {
      "id": "ec_b08066c1fc70e50889d8f345",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-36f6-72be-98b9-887d4b81febe.webp",
      "image_media": {
        "alt_text": "Exterior view of two modern townhouses with garages under a bright blue sky with clouds.",
        "public_id": "019fec2e-36f6-72be-98b9-887d4b81febe",
        "storage_key": "property/6767906449167638/019fec2e-36f6-72be-98b9-887d4b81febe.webp",
        "width": 1981,
        "height": 1394
      },
      "title": "Apartment",
      "description": "View the exteriors of these beautiful townhomes, featuring spacious layouts and modern designs. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "A two-story house with a garage on the ground floor and a living area on the upper floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court---Row-of-Homes-4.jpg"
    },
    {
      "id": "ec_08a0440b5da3c5fb967c0eb8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-3a79-7526-be6b-c882ec7bbb2f.webp",
      "image_media": {
        "alt_text": "Two-story townhomes with white siding, black shutters, and attached garages.",
        "public_id": "019fec2e-3a79-7526-be6b-c882ec7bbb2f",
        "storage_key": "property/6767906449167638/019fec2e-3a79-7526-be6b-c882ec7bbb2f.webp",
        "width": 1891,
        "height": 1330
      },
      "title": "Community",
      "description": "Discover comfortable living in these charming two-story townhomes, featuring modern white siding, classic black shutters, and convenient attached garages. Your ideal home awaits.",
      "link": "false",
      "alt_text": "Two houses with garages are situated in a sunny suburban area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court---Row-of-Homes-5.jpg"
    },
    {
      "id": "ec_3a844ffde05f8f8f79afa200",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-3bbc-725f-82a6-4f9c377f4ec0.webp",
      "image_media": {
        "alt_text": "Two-story houses with garages and manicured lawns under a bright blue sky.",
        "public_id": "019fec2e-3bbc-725f-82a6-4f9c377f4ec0",
        "storage_key": "property/6767906449167638/019fec2e-3bbc-725f-82a6-4f9c377f4ec0.webp",
        "width": 1805,
        "height": 1269
      },
      "title": "Community",
      "description": "Exterior view of two modern two-story houses, featuring attached garages, clean lines, and a bright blue sky overhead.",
      "link": "false",
      "alt_text": "Two houses with garages are situated in a suburban neighborhood.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-Court---Row-of-Homes-6.jpg"
    },
    {
      "id": "ec_cd7d928133dc13aabc60b6dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2e-40c9-7038-82c3-ce247128ef68.webp",
      "image_media": {
        "alt_text": "Aerial view of a suburban neighborhood with rows of houses and green spaces.",
        "public_id": "019fec2e-40c9-7038-82c3-ce247128ef68",
        "storage_key": "property/6767906449167638/019fec2e-40c9-7038-82c3-ce247128ef68.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Discover this charming neighborhood with beautifully designed homes, ample green spaces, and a serene pond. An ideal setting for comfortable living.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential area with houses and a pond.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella%20Court%20aerial.jpg"
    },
    {
      "id": "ec_d59c1699ce3a3dba6d9f8f90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-3b24-76dc-bd24-85ff994c23c2.webp",
      "image_media": {
        "alt_text": "Aerial view of a neighborhood with modern townhouses and dense green trees.",
        "public_id": "019fec2f-3b24-76dc-bd24-85ff994c23c2",
        "storage_key": "property/6767906449167638/019fec2f-3b24-76dc-bd24-85ff994c23c2.webp",
        "width": 1620,
        "height": 1079
      },
      "title": "Community",
      "description": "Discover our beautiful community featuring modern townhouses nestled amidst lush greenery, offering a serene and picturesque living environment.",
      "link": "false",
      "alt_text": "A bird's eye view of a residential area with houses and a winding road.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Isabella-court-aerial-september-2024(1).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_95f9307d-7e13-4b98-b425-652c498f5176",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Port City Java",
      "poi_type": "Restaurants",
      "poi_address": "1112 East Cutlar Crossing, Leland, NC 28451, USA",
      "poi_short_description": "Coffeehouse chain with house-roasted, organic java, plus breakfast items, sandwiches & baked goods.",
      "poi_long_description": "Coffeehouse chain with house-roasted, organic java, plus breakfast items, sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-89ef-77cc-8e48-948a1abc12af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-89ef-77cc-8e48-948a1abc12af",
        "storage_key": "property/6767906449167638/019fec2f-89ef-77cc-8e48-948a1abc12af.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.portcityjava.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809091241329991573",
      "poi_item_slug": "port-city-java",
      "poi_latitude": "34.20212",
      "poi_longitude": "-78.0448633",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-383-1238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc44-772a-88ce-e7351e987954.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc44-772a-88ce-e7351e987954",
        "storage_key": "property/6767906449167638/019fec2f-cc44-772a-88ce-e7351e987954.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJEWg_t2kZqokRlZ-GdE2c3DQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_f5795e3d-2e74-491d-b9ba-ac3d7f8be0a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Pizzettas",
      "poi_type": "Restaurants",
      "poi_address": "1144 East Cutlar Crossing #105, Leland, NC 28451, USA",
      "poi_short_description": "Casual restaurant dishing up pizza and other classic Italian dishes in the Villages at Brunswick Forest.",
      "poi_long_description": "Casual restaurant dishing up pizza and other classic Italian dishes in the Villages at Brunswick Forest.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-8942-72b6-9e61-bc3503b65225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-8942-72b6-9e61-bc3503b65225",
        "storage_key": "property/6767906449167638/019fec2f-8942-72b6-9e61-bc3503b65225.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://pizzettaspizzanc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16838052765682817188",
      "poi_item_slug": "pizzettas",
      "poi_latitude": "34.2018352",
      "poi_longitude": "-78.046604",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-541-5811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcYSvz2gZqokRpNjOT8fHrOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_103b8b06-b344-4ffe-8e1a-8ece94f1dee6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Farmhouse Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "1120 East Cutlar Crossing, Leland, NC 28451, USA",
      "poi_short_description": "Charming eatery with a cute patio for breakfast plates, burgers, sandwiches and pancakes.",
      "poi_long_description": "Charming eatery with a cute patio for breakfast plates, burgers, sandwiches and pancakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-8ddc-701b-9489-87ce2487fc80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-8ddc-701b-9489-87ce2487fc80",
        "storage_key": "property/6767906449167638/019fec2f-8ddc-701b-9489-87ce2487fc80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://farmhousekitchennc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9507524119070127264",
      "poi_item_slug": "farmhouse-kitchen",
      "poi_latitude": "34.2022023",
      "poi_longitude": "-78.0452969",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-408-1676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWRgPNLgZqokRoDSiMtCC8YM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_45602f99-7784-4dc2-845e-2c9b67843539",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Brunswick Beer and Cider",
      "poi_type": "Restaurants",
      "poi_address": "1313 S Dickinson Dr, Leland, NC 28451, USA",
      "poi_short_description": "Relaxed, craft-beer brewery offering a menu of burgers, brick-oven-style pizzas and salads.",
      "poi_long_description": "Relaxed, craft-beer brewery offering a menu of burgers, brick-oven-style pizzas and salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-91ba-73dd-9964-88d9345dd431.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-91ba-73dd-9964-88d9345dd431",
        "storage_key": "property/6767906449167638/019fec2f-91ba-73dd-9964-88d9345dd431.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.brunswickbeerandcider.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16037339417398784449",
      "poi_item_slug": "brunswick-beer-and-cider",
      "poi_latitude": "34.1991493",
      "poi_longitude": "-78.0453461",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 11 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-599-6849",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4U_lXesZqokRwbFsDDsTkN4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_6e3bed46-e61a-4713-9bef-98c2e32ba25a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Shuckin' Shack Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "1175 Turlington Ave Unit 101, Leland, NC 28451, USA",
      "poi_short_description": "Family-friendly hub for steamed & raw shellfish, wings & beers served in a no-frills setting.",
      "poi_long_description": "Family-friendly hub for steamed & raw shellfish, wings & beers served in a no-frills setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-899c-7139-a251-f8190c6d4d5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-899c-7139-a251-f8190c6d4d5f",
        "storage_key": "property/6767906449167638/019fec2f-899c-7139-a251-f8190c6d4d5f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.theshuckinshack.com/location-leland",
      "poi_directions_map_url": "https://maps.google.com/?cid=12657734132984526112",
      "poi_item_slug": "shuckin-shack-oyster-bar",
      "poi_latitude": "34.2003212",
      "poi_longitude": "-78.047234",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-834-2060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzJZwGgZqokRIDXhYSFOqa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_ade253ff-276b-4bae-aa21-8e1de00492e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Leland Smoke House",
      "poi_type": "Restaurants",
      "poi_address": "503 Olde Waterford Way Ste 100, Leland, NC 28451, USA",
      "poi_short_description": "Barbecue restaurant on Olde Waterford Way in Leland.",
      "poi_long_description": "Barbecue restaurant on Olde Waterford Way in Leland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-8cf8-765a-b8ac-09ce4e5d342b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-8cf8-765a-b8ac-09ce4e5d342b",
        "storage_key": "property/6767906449167638/019fec2f-8cf8-765a-b8ac-09ce4e5d342b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lelandsmokehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221007844648889329",
      "poi_item_slug": "leland-smoke-house",
      "poi_latitude": "34.2160625",
      "poi_longitude": "-78.0206316",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 18 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 910-228-5008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF1zXo14ZqokR8SvzOJZ0erc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_b45e84c3-ba2c-4b5b-8f1f-93092b129571",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Six Happiness",
      "poi_type": "Restaurants",
      "poi_address": "1114 New Pointe Blvd, Leland, NC 28451, USA",
      "poi_short_description": "Family-run restaurant serving sushi and other Asian dishes, like pad thai.",
      "poi_long_description": "Family-run restaurant serving sushi and other Asian dishes, like pad thai.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-93a3-74f0-9fd0-ba20ff544b71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-93a3-74f0-9fd0-ba20ff544b71",
        "storage_key": "property/6767906449167638/019fec2f-93a3-74f0-9fd0-ba20ff544b71.webp",
        "width": 1280,
        "height": 690
      },
      "poi_business_url": "http://www.sixhappinessnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13801191887009194767",
      "poi_item_slug": "six-happiness",
      "poi_latitude": "34.2118471",
      "poi_longitude": "-78.021855",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 910-371-0021",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfa29DQZqokRD6MvPuauh78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_47d1a63a-3650-4d57-ad3d-d47c16b3880c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "San Felipe Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1114 New Pointe Blvd #140, Leland, NC 28451, USA",
      "poi_short_description": "Casual spot at the Shops at Westgate serving Mexican dishes such as fajitas, with a kids' menu.",
      "poi_long_description": "Casual spot at the Shops at Westgate serving Mexican dishes such as fajitas, with a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-966b-7230-b7ff-7c509a5990d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-966b-7230-b7ff-7c509a5990d9",
        "storage_key": "property/6767906449167638/019fec2f-966b-7230-b7ff-7c509a5990d9.webp",
        "width": 1280,
        "height": 1239
      },
      "poi_business_url": "http://www.sanfelipenc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15525661225040487436",
      "poi_item_slug": "san-felipe-mexican-restaurant",
      "poi_latitude": "34.2116766",
      "poi_longitude": "-78.02174649999999",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 910-399-2706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfa29DQZqokRDCSYLaA6dtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2667d2fc-1e4c-4d93-9ab0-f8259d70e6ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1735 Reed Rd NE, Leland, NC 28451, USA",
      "poi_short_description": "Grocery chain offering produce, meat, bulk goods, and prepared foods, including a wing bar.",
      "poi_long_description": "Grocery chain offering produce, meat, bulk goods, and prepared foods, including a wing bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-55fd-7059-9586-539fc9431f1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-55fd-7059-9586-539fc9431f1a",
        "storage_key": "property/6767906449167638/019fec2c-55fd-7059-9586-539fc9431f1a.webp",
        "width": 400,
        "height": 300
      },
      "poi_business_url": "https://stores.foodlion.com/nc/leland/1735-reed-rd?y_source=1_NTA0NjgxMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15825736663071218778",
      "poi_item_slug": "food-lion",
      "poi_latitude": "34.2605794",
      "poi_longitude": "-78.05776209999999",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 910-383-1467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a7-7118-b87e-5b513dc623d1",
        "storage_key": "property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD9TL9o4YqokRWlw8j6VPoNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e0879a09-09ae-453d-8c5e-5230d52b6d1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Piggly Wiggly-Leland",
      "poi_type": "Shopping & Retail",
      "poi_address": "112 Village Rd NE # A, Leland, NC 28451, USA",
      "poi_short_description": "Chain store carrying meat, produce and staples, plus a deli.",
      "poi_long_description": "Chain store carrying meat, produce and staples, plus a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-999b-71ce-a312-bf22097cb493.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-999b-71ce-a312-bf22097cb493",
        "storage_key": "property/6767906449167638/019fec2f-999b-71ce-a312-bf22097cb493.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pigglywigglystores.com/stores/piggly-wiggly-leland",
      "poi_directions_map_url": "https://maps.google.com/?cid=1695584526015323487",
      "poi_item_slug": "piggly-wiggly-leland",
      "poi_latitude": "34.235404",
      "poi_longitude": "-77.9970475",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 910-371-2696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a7-7118-b87e-5b513dc623d1",
        "storage_key": "property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77YSiRgfqokRX93KjyTthxc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_bd6f32cf-ba68-4d97-bcff-1f4e92682737",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "117A Village Rd NE, Leland, NC 28451, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-99e9-7453-9ac8-f2fca2532f86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-99e9-7453-9ac8-f2fca2532f86",
        "storage_key": "property/6767906449167638/019fec2f-99e9-7453-9ac8-f2fca2532f86.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/leland-nc-pharmacies/117a-village-rd-leland-nc-28451/storeid=5563?WT.mc_id=LS_GOOGLE_FS_5563",
      "poi_directions_map_url": "https://maps.google.com/?cid=245442940495974296",
      "poi_item_slug": "cvs",
      "poi_latitude": "34.2337599",
      "poi_longitude": "-77.9997648",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 910-371-6363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh81HtiMfqokRmM_j0A39ZwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_c0bbf01f-d4a1-4390-ab26-e464816323d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1019 Grandiflora Dr, Leland, NC 28451, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-9b67-732a-ad66-24444230a0f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-9b67-732a-ad66-24444230a0f6",
        "storage_key": "property/6767906449167638/019fec2f-9b67-732a-ad66-24444230a0f6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1019+grandiflora+dr-leland-nc-28451/id=11352",
      "poi_directions_map_url": "https://maps.google.com/?cid=18315416270377873940",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.2114375",
      "poi_longitude": "-78.0284207",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 910-371-0233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_QgtIjcZqokRFHJIBQ9uLf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_6286f66d-852d-4028-9cde-6f404cba02bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1112 New Pointe Blvd, Leland, NC 28451, USA",
      "poi_short_description": "Chain retailer offering a wide selection of merchandise, from clothing and electronics to toys and groceries.",
      "poi_long_description": "Chain retailer offering a wide selection of merchandise, from clothing and electronics to toys and groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-99e9-7453-9ac8-f73b87951e94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-99e9-7453-9ac8-f73b87951e94",
        "storage_key": "property/6767906449167638/019fec2f-99e9-7453-9ac8-f73b87951e94.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4273-leland-nc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=17545591532194888273",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "34.2097444",
      "poi_longitude": "-78.0229278",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 910-383-1769",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-759a-779d-837f-ab7966f5dd1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-759a-779d-837f-ab7966f5dd1a",
        "storage_key": "property/6767906449167638/019fec2c-759a-779d-837f-ab7966f5dd1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi7-8sjUZqokRUfqTuol2fvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_fe071128-0494-4725-90e5-fe89ab7b7a9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Lowes Foods of Leland",
      "poi_type": "Shopping & Retail",
      "poi_address": "1152 East Cutlar Crossing, Leland, NC 28451, USA",
      "poi_short_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_long_description": "Supermarket chain known for chicken prepared on-site, plus pantry staples, produce, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-9bee-722a-a61a-a8f0d2c05ee0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-9bee-722a-a61a-a8f0d2c05ee0",
        "storage_key": "property/6767906449167638/019fec2f-9bee-722a-a61a-a8f0d2c05ee0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lowesfoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8542352842431730758",
      "poi_item_slug": "lowes-foods-of-leland",
      "poi_latitude": "34.2015191",
      "poi_longitude": "-78.0471543",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 7 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-371-5544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a7-7118-b87e-5b513dc623d1",
        "storage_key": "property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ92d612gZqokRRhQxn6aIjHY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0b2b07c0-ea79-4ebc-ae64-560001b873f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2021 Olde Regent Way, Leland, NC 28451, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-9bf1-717d-a855-008172fec8fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-9bf1-717d-a855-008172fec8fd",
        "storage_key": "property/6767906449167638/019fec2f-9bf1-717d-a855-008172fec8fd.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/nc/leland/waterford-village/097/00225?cid=loc_09700225_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=18177999390306214642",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "34.2194442",
      "poi_longitude": "-78.0193704",
      "poi_miles_from_property": "11.6 mi",
      "poi_walking_minutes": "4 hours 14 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 910-371-3944",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a7-7118-b87e-5b513dc623d1",
        "storage_key": "property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFWDOqZUYqokR8iJ4YiI6Rfw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_098c8c94-8828-4b30-8361-61ddce81971c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "9410 Ploof Rd SE, Leland, NC 28451, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-9f08-75cd-8c95-ad6c6d8aeffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-9f08-75cd-8c95-ad6c6d8aeffe",
        "storage_key": "property/6767906449167638/019fec2f-9f08-75cd-8c95-ad6c6d8aeffe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://info.aldi.us/stores/l/nc/leland/9410-ploof-rd-se/fc60",
      "poi_directions_map_url": "https://maps.google.com/?cid=14553485863848183700",
      "poi_item_slug": "aldi",
      "poi_latitude": "34.2150716",
      "poi_longitude": "-78.01871179999999",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a7-7118-b87e-5b513dc623d1",
        "storage_key": "property/6767906449167638/019fec2c-75a7-7118-b87e-5b513dc623d1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTJl18weqokRlAdXFkle-Mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_df65e596-5a55-46de-98e7-8d43b2d64b19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Lincoln Elementary School",
      "poi_type": "Education",
      "poi_address": "1664 Lincoln Rd NE, Leland, NC 28451, USA",
      "poi_short_description": "Public elementary school, Brunswick County Schools.",
      "poi_long_description": "Public elementary school, Brunswick County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-9d67-7393-a446-edad4aa361eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-9d67-7393-a446-edad4aa361eb",
        "storage_key": "property/6767906449167638/019fec2f-9d67-7393-a446-edad4aa361eb.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://les.bcswan.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9262349743616249188",
      "poi_item_slug": "lincoln-elementary-school",
      "poi_latitude": "34.2618984",
      "poi_longitude": "-78.0433874",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 910-371-3597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e65af7fb1e30",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKb7Vgr0YqokRZE2tjQR6ioA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cfcc34bd-3650-4c64-bad9-0020ca23ad0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Leland Middle School",
      "poi_type": "Education",
      "poi_address": "927 Old Fayetteville Rd, Leland, NC 28451, USA",
      "poi_short_description": "Public middle school, Brunswick County Schools.",
      "poi_long_description": "Public middle school, Brunswick County Schools.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://lms.bcswan.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14717214825425871090",
      "poi_item_slug": "leland-middle-school",
      "poi_latitude": "34.23703",
      "poi_longitude": "-78.0343551",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 910-371-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e65af7fb1e30",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq5oyONoYqokR8iCfmOgMPsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_37d80b0e-645c-4e84-b4d6-4e2b34525149",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "North Brunswick High School",
      "poi_type": "Education",
      "poi_address": "114 Scorpion Dr NE, Leland, NC 28451, USA",
      "poi_short_description": "Public high school, Brunswick County Schools.",
      "poi_long_description": "Public high school, Brunswick County Schools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-9f11-751f-9f67-32861c2ba551.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-9f11-751f-9f67-32861c2ba551",
        "storage_key": "property/6767906449167638/019fec2f-9f11-751f-9f67-32861c2ba551.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://nbhs.bcswan.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16863675178031558893",
      "poi_item_slug": "north-brunswick-high-school",
      "poi_latitude": "34.2402133",
      "poi_longitude": "-78.0240184",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 31 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 910-371-2261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e65af7fb1e30",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6U5Aic0YqokR7bAkEjrPB-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_9b947191-78a8-4c03-afbe-8080060c2fcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Leland Center - Brunswick Community College",
      "poi_type": "Education",
      "poi_address": "2045 Enterprise Dr NE, Leland, NC 28451, USA",
      "poi_short_description": "Brunswick Community College's Leland campus, on Enterprise Drive off US-74/76.",
      "poi_long_description": "Brunswick Community College's Leland campus, on Enterprise Drive off US-74/76.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-53d4-772f-a385-3e4254b76967.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-53d4-772f-a385-3e4254b76967",
        "storage_key": "property/6767906449167638/019fec2c-53d4-772f-a385-3e4254b76967.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brunswickcc.edu/leland-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6106009299778375995",
      "poi_item_slug": "leland-center---brunswick-community-college",
      "poi_latitude": "34.2597084",
      "poi_longitude": "-78.07141109999999",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 910-755-8084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e65af7fb1e30",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfZypzmYYqokRO5GFbBvnvFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_15f4390b-2062-46b9-bd03-fe49a4747c36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "BRUNSWICK BEER XCHANGE",
      "poi_type": "Restaurants",
      "poi_address": "113 Village Rd NE, Leland, NC 28451, USA",
      "poi_short_description": "Laid-back tap house offering 40 beers on tap, plus a fridge full of brews and a wine selection.",
      "poi_long_description": "Laid-back tap house offering 40 beers on tap, plus a fridge full of brews and a wine selection.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a275-751e-9af3-580e52426acd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a275-751e-9af3-580e52426acd",
        "storage_key": "property/6767906449167638/019fec2f-a275-751e-9af3-580e52426acd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bbxchange.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4935199318558410782",
      "poi_item_slug": "brunswick-beer-xchange",
      "poi_latitude": "34.2333877",
      "poi_longitude": "-77.9975518",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 910-408-1877",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a5-72f3-9325-1a851c585a4a",
        "storage_key": "property/6767906449167638/019fec2c-75a5-72f3-9325-1a851c585a4a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZEbu4IfqokRHohs5qFZfUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_9b273d06-0d01-4a1e-8717-a3125b5c2c9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Battleship North Carolina",
      "poi_type": "Entertainment",
      "poi_address": "1 Battleship Rd NE, Wilmington, NC 28401, USA",
      "poi_short_description": "Exhibits memorializing the battleship's service in World War II plus a visitors center & gift shop.",
      "poi_long_description": "Exhibits memorializing the battleship's service in World War II plus a visitors center & gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a35e-728b-b824-99d98a2fcaee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a35e-728b-b824-99d98a2fcaee",
        "storage_key": "property/6767906449167638/019fec2f-a35e-728b-b824-99d98a2fcaee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://battleshipnc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11326086436581725497",
      "poi_item_slug": "battleship-north-carolina",
      "poi_latitude": "34.2365524",
      "poi_longitude": "-77.9543704",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 25 mins",
      "poi_biking_minutes": "3 hours 53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 910-399-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc44-772a-88ce-e0eaa2b9245f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc44-772a-88ce-e0eaa2b9245f",
        "storage_key": "property/6767906449167638/019fec2f-cc44-772a-88ce-e0eaa2b9245f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWa0xSLgfqokROdXSG5tXLp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_e2885a5e-986f-4417-9655-ca59ae82bd83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Thalian Hall Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "310 Chestnut St, Wilmington, NC 28401, USA",
      "poi_short_description": "Venerable performing arts venue dating to 1858, with 2 stages for films, concerts & live theater.",
      "poi_long_description": "Venerable performing arts venue dating to 1858, with 2 stages for films, concerts & live theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a2f4-7138-85d0-60d15e55aad0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a2f4-7138-85d0-60d15e55aad0",
        "storage_key": "property/6767906449167638/019fec2f-a2f4-7138-85d0-60d15e55aad0.webp",
        "width": 1000,
        "height": 800
      },
      "poi_business_url": "http://www.thalianhall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2595995531787354740",
      "poi_item_slug": "thalian-hall-center-for-the-performing-arts",
      "poi_latitude": "34.237249",
      "poi_longitude": "-77.945638",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 19 mins",
      "poi_biking_minutes": "4 hours 29 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 910-632-2285",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkVexscYfqokRdMKvli7UBiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0089692a-fc14-4f11-a00f-756bb23201ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Cameron Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "3201 S 17th St, Wilmington, NC 28412, USA",
      "poi_short_description": "Art museum showcasing local & international artists plus a cafe & special events.",
      "poi_long_description": "Art museum showcasing local & international artists plus a cafe & special events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a4e5-724a-8920-56e09b8a638a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a4e5-724a-8920-56e09b8a638a",
        "storage_key": "property/6767906449167638/019fec2f-a4e5-724a-8920-56e09b8a638a.webp",
        "width": 680,
        "height": 510
      },
      "poi_business_url": "https://cameronartmuseum.org/?utm_source=google&utm_medium=organic&utm_campaign=website_gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17203998642764648491",
      "poi_item_slug": "cameron-art-museum",
      "poi_latitude": "34.1840949",
      "poi_longitude": "-77.9154152",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "19 hours 46 mins",
      "poi_biking_minutes": "5 hours 7 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 910-395-5999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc44-772a-88ce-e0eaa2b9245f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc44-772a-88ce-e0eaa2b9245f",
        "storage_key": "property/6767906449167638/019fec2f-cc44-772a-88ce-e0eaa2b9245f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJa2qFPeX1qYkRKxBKap3hwO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_a8263ac3-9a96-46b7-a1cc-78bab94ccb6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Airlie Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "300 Airlie Rd, Wilmington, NC 28403, USA",
      "poi_short_description": "Expansive gardens filled with azaleas, walking trails & 10 acres of freshwater lakes.",
      "poi_long_description": "Expansive gardens filled with azaleas, walking trails & 10 acres of freshwater lakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a55d-721a-8a03-e66fea33d7a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a55d-721a-8a03-e66fea33d7a2",
        "storage_key": "property/6767906449167638/019fec2f-a55d-721a-8a03-e66fea33d7a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://airliegardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8978538966993954822",
      "poi_item_slug": "airlie-gardens",
      "poi_latitude": "34.2182979",
      "poi_longitude": "-77.8302416",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "19 hours 11 mins",
      "poi_biking_minutes": "5 hours 17 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 910-798-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXIY6nnzqYkRBmitwZ4tmnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_bd929f34-778a-4a31-b7c8-8c33a4a55b21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Jungle Rapids Family Fun Park",
      "poi_type": "Entertainment",
      "poi_address": "5320 Oleander Dr, Wilmington, NC 28403, USA",
      "poi_short_description": "Amusement park with a water park, go-kart course, laser tag, mini-golf, jungle gym & more.",
      "poi_long_description": "Amusement park with a water park, go-kart course, laser tag, mini-golf, jungle gym & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a66e-7382-b664-0fd6596afc8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a66e-7382-b664-0fd6596afc8b",
        "storage_key": "property/6767906449167638/019fec2f-a66e-7382-b664-0fd6596afc8b.webp",
        "width": 865,
        "height": 1280
      },
      "poi_business_url": "https://www.junglerapids.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8986937617683735289",
      "poi_item_slug": "jungle-rapids-family-fun-park",
      "poi_latitude": "34.207308",
      "poi_longitude": "-77.8630797",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "19 hours 29 mins",
      "poi_biking_minutes": "5 hours 9 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 910-791-0888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEUjrJlz0qYkR-WKiACYEuHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_ddd2e756-5530-4b80-ae73-3398197394b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "The Children's Museum of Wilmington",
      "poi_type": "Entertainment",
      "poi_address": "116 Orange St, Wilmington, NC 28401, USA",
      "poi_short_description": "Museum for kids ages 1 to 10 with hands-on exhibits, outdoor playground,  & party rooms.",
      "poi_long_description": "Museum for kids ages 1 to 10 with hands-on exhibits, outdoor playground,  & party rooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a9f2-7299-ad20-65e72c77ba1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a9f2-7299-ad20-65e72c77ba1c",
        "storage_key": "property/6767906449167638/019fec2f-a9f2-7299-ad20-65e72c77ba1c.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "http://www.playwilmington.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7501251796735649530",
      "poi_item_slug": "the-childrens-museum-of-wilmington",
      "poi_latitude": "34.2327413",
      "poi_longitude": "-77.9474961",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 29 mins",
      "poi_biking_minutes": "3 hours 55 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 910-254-3534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc44-772a-88ce-e0eaa2b9245f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc44-772a-88ce-e0eaa2b9245f",
        "storage_key": "property/6767906449167638/019fec2f-cc44-772a-88ce-e0eaa2b9245f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJqy6mnMgfqokR-mYwC8TMGWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b15f9041-61eb-40bc-95cd-39b8e19cc716",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Novant Health - New Hanover ExpressCare : Brunswick Forest",
      "poi_type": "Health and Wellness",
      "poi_address": "1333 S Dickinson Dr Suite 140 B, Leland, NC 28451, USA",
      "poi_short_description": "Walk-in urgent care clinic (Novant Health) at The Villages at Brunswick Forest.",
      "poi_long_description": "Walk-in urgent care clinic (Novant Health) at The Villages at Brunswick Forest.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-a9fa-732a-8b14-eeb3634b32ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-a9fa-732a-8b14-eeb3634b32ee",
        "storage_key": "property/6767906449167638/019fec2f-a9fa-732a-8b14-eeb3634b32ee.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.novanthealth.org/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=HAN-MG-042",
      "poi_directions_map_url": "https://maps.google.com/?cid=1607214095632195610",
      "poi_item_slug": "novant-health---new-hanover-expresscare--brunswick-forest",
      "poi_latitude": "34.1986633",
      "poi_longitude": "-78.04657759999999",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-662-6643",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXynheMZqokRGmAoYLT4TRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_624b5786-1f4f-4fc5-8d94-f3c775a0fa0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "4ever24fit",
      "poi_type": "Health and Wellness",
      "poi_address": "477 Olde Waterford Way STE 115, Belville, NC 28451, USA",
      "poi_short_description": "Equipment-filled fitness center offering 24-hour access, with membership required.",
      "poi_long_description": "Equipment-filled fitness center offering 24-hour access, with membership required.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-afdc-721a-a9c2-52dd58bbc1fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-afdc-721a-a9c2-52dd58bbc1fa",
        "storage_key": "property/6767906449167638/019fec2f-afdc-721a-a9c2-52dd58bbc1fa.webp",
        "width": 1280,
        "height": 908
      },
      "poi_business_url": "http://www.4ever24fit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4093503031145035628",
      "poi_item_slug": "4ever24fit",
      "poi_latitude": "34.21561459999999",
      "poi_longitude": "-78.0211437",
      "poi_miles_from_property": "11.8 mi",
      "poi_walking_minutes": "4 hours 19 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 910-399-4760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOWTpyjIZqokRbHdiilELzzg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_11cba4ea-b2e1-47f7-939b-0eb417e6c297",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Westgate Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1260 W Gate Dr, Leland, NC 28451, USA",
      "poi_short_description": "Wooded park featuring playgrounds and information about animals and trees.",
      "poi_long_description": "Wooded park featuring playgrounds and information about animals and trees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-b0a0-71e6-9fd5-472171e94f05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-b0a0-71e6-9fd5-472171e94f05",
        "storage_key": "property/6767906449167638/019fec2f-b0a0-71e6-9fd5-472171e94f05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.townofleland.com/parks-recreation-cultural-resources/parks-facilities",
      "poi_directions_map_url": "https://maps.google.com/?cid=9788165888071163350",
      "poi_item_slug": "westgate-nature-park",
      "poi_latitude": "34.2071747",
      "poi_longitude": "-78.01497499999999",
      "poi_miles_from_property": "12.6 mi",
      "poi_walking_minutes": "4 hours 35 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 910-332-4818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e3b603c71fbe",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP2WvO8oeqokR1t0T6QON1oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b1e15003-bb3b-4969-b329-36056ddb277d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Founders Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "113 Town Hall Dr, Leland, NC 28451, USA",
      "poi_short_description": "Open-air area featuring playgrounds, walking trails, and disc golf.",
      "poi_long_description": "Open-air area featuring playgrounds, walking trails, and disc golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-b1af-73ff-b3bb-f6496495d973.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-b1af-73ff-b3bb-f6496495d973",
        "storage_key": "property/6767906449167638/019fec2f-b1af-73ff-b3bb-f6496495d973.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.townofleland.com/projects/founders-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13703093579113450826",
      "poi_item_slug": "founders-park",
      "poi_latitude": "34.2371838",
      "poi_longitude": "-78.010505",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 910-371-0148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e3b603c71fbe",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ83puCS8fqokRSk3-EgIrK74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1c95c17f-1a2d-4915-9b66-db4d700e3291",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Cypress Cove Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "844 Appleton Way NE, Leland, NC 28451, USA",
      "poi_short_description": "Neighborhood park on Appleton Way in Leland.",
      "poi_long_description": "Neighborhood park on Appleton Way in Leland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-b228-7698-bd4a-5c22ec04cb7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-b228-7698-bd4a-5c22ec04cb7f",
        "storage_key": "property/6767906449167638/019fec2f-b228-7698-bd4a-5c22ec04cb7f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ncbrunswick.com/listing/cypress-cove-park/174/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10120850141063715753",
      "poi_item_slug": "cypress-cove-park",
      "poi_latitude": "34.249298",
      "poi_longitude": "-78.019333",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 910-371-0148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e3b603c71fbe",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCed7NDUfqokRqZsQq5R7dIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_81f6dcc8-54c8-4936-ad6b-8567e7979c3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Leland Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1490 Village Rd NE, Leland, NC 28451, USA",
      "poi_short_description": "Park with a playground and picnic tables, plus a baseball field.",
      "poi_long_description": "Park with a playground and picnic tables, plus a baseball field.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-6849-7469-bd8f-36917f6d105b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-6849-7469-bd8f-36917f6d105b",
        "storage_key": "property/6767906449167638/019fec2c-6849-7469-bd8f-36917f6d105b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.brunswickcountync.gov/Facilities/Facility/Details/Leland-Community-Park-9",
      "poi_directions_map_url": "https://maps.google.com/?cid=18209975457232332141",
      "poi_item_slug": "leland-community-park",
      "poi_latitude": "34.2574897",
      "poi_longitude": "-78.0465318",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 910-371-9606",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e3b603c71fbe",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJhyU6QpQYqokRbSXqoDLUtvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c81a06c3-3536-453f-8d28-4fccfa70f04e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Northwest District Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1937 Andrew Jackson Hwy, Leland, NC 28451, USA",
      "poi_short_description": "Outdoor venue offering a playground and athletic facilities, including baseball fields, tennis courts, and a basketball court.",
      "poi_long_description": "Outdoor venue offering a playground and athletic facilities, including baseball fields, tennis courts, and a basketball court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-6853-72bc-a97d-cdc57eed7ad1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2c-6853-72bc-a97d-cdc57eed7ad1",
        "storage_key": "property/6767906449167638/019fec2c-6853-72bc-a97d-cdc57eed7ad1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brunswickcountync.gov/Facilities/Facility/Details/Northwest-District-Park-12",
      "poi_directions_map_url": "https://maps.google.com/?cid=5239414777520838920",
      "poi_item_slug": "northwest-district-park",
      "poi_latitude": "34.2550304",
      "poi_longitude": "-78.0673327",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 910-371-9222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e3b603c71fbe",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJs76Q0V8YqokRCNkPBfsjtkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8c65581f-6678-48af-ab76-b9174b4406a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "The Belville Riverwalk Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "580 River Rd SE, Belville, NC 28451, USA",
      "poi_short_description": "Multi-use park featuring a playground, a nature trail and scenic water views.",
      "poi_long_description": "Multi-use park featuring a playground, a nature trail and scenic water views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-b6c2-76eb-8fe9-f9210a862d5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-b6c2-76eb-8fe9-f9210a862d5a",
        "storage_key": "property/6767906449167638/019fec2f-b6c2-76eb-8fe9-f9210a862d5a.webp",
        "width": 720,
        "height": 406
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12190831948027455459",
      "poi_item_slug": "the-belville-riverwalk-park",
      "poi_latitude": "34.2216538",
      "poi_longitude": "-77.98254179999999",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "4 hours 56 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 910-371-2456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e3b603c71fbe",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e3b603c71fbe.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwhgE_weqokR4-eoIhGJLqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6a339371-1551-4f27-bc75-8b097ee913cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Brunswick Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2601 River Rd SE, Winnabow, NC 28479, USA",
      "poi_short_description": "Picturesque park featuring dirt trails for hiking, biking, kayaking and horseback riding.",
      "poi_long_description": "Picturesque park featuring dirt trails for hiking, biking, kayaking and horseback riding.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-b73e-7709-a4ae-23ac0e1f9e76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-b73e-7709-a4ae-23ac0e1f9e76",
        "storage_key": "property/6767906449167638/019fec2f-b73e-7709-a4ae-23ac0e1f9e76.webp",
        "width": 1280,
        "height": 788
      },
      "poi_business_url": "https://www.ncbrunswick.com/listing/brunswick-nature-park/131/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10594347594753614322",
      "poi_item_slug": "brunswick-nature-park",
      "poi_latitude": "34.1408058",
      "poi_longitude": "-77.98934299999999",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 910-253-2670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc64-7468-8a12-832c9cea59d8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc64-7468-8a12-832c9cea59d8",
        "storage_key": "property/6767906449167638/019fec2f-cc64-7468-8a12-832c9cea59d8.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJgx9W4VgcqokR8qFNlAGvBpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_68fdd49b-a4b2-479b-9001-6d6e62da74f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Padgett Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "520 N 3rd St, Wilmington, NC 28401, USA",
      "poi_short_description": "Wave Transit's downtown Wilmington transfer station for local bus routes.",
      "poi_long_description": "Wave Transit's downtown Wilmington transfer station for local bus routes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-bbe1-7288-afea-6fe92d34487c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-bbe1-7288-afea-6fe92d34487c",
        "storage_key": "property/6767906449167638/019fec2f-bbe1-7288-afea-6fe92d34487c.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.wavetransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8351894433346176761",
      "poi_item_slug": "padgett-station",
      "poi_latitude": "34.2420787",
      "poi_longitude": "-77.94644699999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 13 mins",
      "poi_biking_minutes": "4 hours 27 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 910-343-0106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvyDfkRQfqokR-UYppbzj53M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_74575cbd-6af8-474f-be92-0c2c771ec471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Wilmington International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1740 Airport Blvd, Wilmington, NC 28405, USA",
      "poi_short_description": "Commercial airport serving the Wilmington area (ILM), on Airport Boulevard north of downtown.",
      "poi_long_description": "Commercial airport serving the Wilmington area (ILM), on Airport Boulevard north of downtown.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-bbfd-70d7-b828-c2db9b354816.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-bbfd-70d7-b828-c2db9b354816",
        "storage_key": "property/6767906449167638/019fec2f-bbfd-70d7-b828-c2db9b354816.webp",
        "width": 1280,
        "height": 781
      },
      "poi_business_url": "http://www.flyilm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16633840932591688411",
      "poi_item_slug": "wilmington-international-airport",
      "poi_latitude": "34.267045",
      "poi_longitude": "-77.91046659999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "17 hours 39 mins",
      "poi_biking_minutes": "4 hours 35 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 910-341-4125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc4e-758a-b9c3-63da098c4ad2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc4e-758a-b9c3-63da098c4ad2",
        "storage_key": "property/6767906449167638/019fec2f-cc4e-758a-b9c3-63da098c4ad2.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQd6TGcaKqYkR29p6xTJG1-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_94587514-defe-4d76-b889-59d0e0d3d1b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Port of Wilmington",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2202 Burnett Blvd, Wilmington, NC 28401, USA",
      "poi_short_description": "Deep-water seaport on the Cape Fear River, operated by the North Carolina State Ports Authority.",
      "poi_long_description": "Deep-water seaport on the Cape Fear River, operated by the North Carolina State Ports Authority.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-bf24-744f-966a-8b65c4cf411c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-bf24-744f-966a-8b65c4cf411c",
        "storage_key": "property/6767906449167638/019fec2f-bf24-744f-966a-8b65c4cf411c.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://ncports.com/port-facilities/port-of-wilmington/",
      "poi_directions_map_url": "https://maps.google.com/?cid=71813021916021403",
      "poi_item_slug": "port-of-wilmington",
      "poi_latitude": "34.1962817",
      "poi_longitude": "-77.94835139999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "19 hours 28 mins",
      "poi_biking_minutes": "4 hours 8 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 910-763-1621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc63-739c-af4d-570eab1b456c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc63-739c-af4d-570eab1b456c",
        "storage_key": "property/6767906449167638/019fec2f-cc63-739c-af4d-570eab1b456c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxcNuaGseqokRm0KNHZAh_wA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_263dd21d-102d-43ff-9a59-b37c4b73a536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "The Villages at Brunswick Forest",
      "poi_type": "Shopping & Retail",
      "poi_address": "1333 S Dickinson Dr, Leland, NC 28451, USA",
      "poi_short_description": "Shopping mall featuring a variety of eateries, including an Irish pub, plus a grocery store.",
      "poi_long_description": "Shopping mall featuring a variety of eateries, including an Irish pub, plus a grocery store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-be3d-71ec-af0b-b32ab73889da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-be3d-71ec-af0b-b32ab73889da",
        "storage_key": "property/6767906449167638/019fec2f-be3d-71ec-af0b-b32ab73889da.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.villagesatbrunswickforest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2103772750353308753",
      "poi_item_slug": "the-villages-at-brunswick-forest",
      "poi_latitude": "34.20123780000001",
      "poi_longitude": "-78.0467855",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 910-341-4224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-759a-779d-837f-ab7966f5dd1a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-759a-779d-837f-ab7966f5dd1a",
        "storage_key": "property/6767906449167638/019fec2c-759a-779d-837f-ab7966f5dd1a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJibRLjGgZqokRUZz0kCsaMh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_69a67241-be15-44e4-af20-712f09b8c9b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Novant Health New Hanover Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2131 S 17th St, Wilmington, NC 28401, USA",
      "poi_short_description": "Regional medical center in Wilmington; the area's main hospital, part of Novant Health.",
      "poi_long_description": "Regional medical center in Wilmington; the area's main hospital, part of Novant Health.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-c1b8-7762-9d4f-205dacf91b5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-c1b8-7762-9d4f-205dacf91b5c",
        "storage_key": "property/6767906449167638/019fec2f-c1b8-7762-9d4f-205dacf91b5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.novanthealth.org/locations/medical-centers/new-hanover-regional-medical-center/?utm_source=maps.google.com&utm_medium=organic&utm_campaign=GBP&utm_content=MC-17",
      "poi_directions_map_url": "https://maps.google.com/?cid=1194466814629763580",
      "poi_item_slug": "novant-health-new-hanover-regional-medical-center",
      "poi_latitude": "34.20563730000001",
      "poi_longitude": "-77.9212311",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "19 hours 10 mins",
      "poi_biking_minutes": "5 hours 2 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 910-667-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-cc45-7736-90dc-e9fcdd3a9e3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2f-cc45-7736-90dc-e9fcdd3a9e3d",
        "storage_key": "property/6767906449167638/019fec2f-cc45-7736-90dc-e9fcdd3a9e3d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1Z9zIY_1qYkR_Nn_RT2ZkxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_488637f3-8d03-4f19-bf00-066018ba452d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "University of North Carolina Wilmington",
      "poi_type": "Education",
      "poi_address": "601 College Rd, Wilmington, NC 28403, USA",
      "poi_short_description": "Public university in Wilmington, part of the University of North Carolina system.",
      "poi_long_description": "Public university in Wilmington, part of the University of North Carolina system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-c097-772f-90f8-d82fc6aa8231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-c097-772f-90f8-d82fc6aa8231",
        "storage_key": "property/6767906449167638/019fec2f-c097-772f-90f8-d82fc6aa8231.webp",
        "width": 1200,
        "height": 733
      },
      "poi_business_url": "http://uncw.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9595827269884436102",
      "poi_item_slug": "university-of-north-carolina-wilmington",
      "poi_latitude": "34.224675",
      "poi_longitude": "-77.8678426",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 54 mins",
      "poi_biking_minutes": "5 hours 5 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 910-962-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e65af7fb1e30",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3T69k_r0qYkRht53ow86K4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7b40561d-c37b-4a49-a246-faabbf335c13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Cape Fear Community College",
      "poi_type": "Education",
      "poi_address": "411 N Front St, Wilmington, NC 28401, USA",
      "poi_short_description": "Public community college with its main campus in downtown Wilmington.",
      "poi_long_description": "Public community college with its main campus in downtown Wilmington.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-c023-74c3-b315-398e71c5c6ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-c023-74c3-b315-398e71c5c6ea",
        "storage_key": "property/6767906449167638/019fec2f-c023-74c3-b315-398e71c5c6ea.webp",
        "width": 1280,
        "height": 846
      },
      "poi_business_url": "https://cfcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9627874553306914480",
      "poi_item_slug": "cape-fear-community-college",
      "poi_latitude": "34.2401448",
      "poi_longitude": "-77.9490308",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 19 mins",
      "poi_biking_minutes": "3 hours 52 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 910-362-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-7599-748a-8e15-e65af7fb1e30",
        "storage_key": "property/6767906449167638/019fec2c-7599-748a-8e15-e65af7fb1e30.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoY5cO8AfqokRsJ7hQ-UUnYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_97d22475-5562-483a-b5ab-04d4f23834d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "nCino, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6770 Parker Farm Dr, Wilmington, NC 28405, USA",
      "poi_short_description": "Wilmington-headquartered banking-software company; one of the area's largest private employers.",
      "poi_long_description": "Wilmington-headquartered banking-software company; one of the area's largest private employers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-c5a4-76bd-a382-95dcab78a005.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-c5a4-76bd-a382-95dcab78a005",
        "storage_key": "property/6767906449167638/019fec2f-c5a4-76bd-a382-95dcab78a005.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://www.ncino.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2449741041533941361",
      "poi_item_slug": "ncino-inc",
      "poi_latitude": "34.2344203",
      "poi_longitude": "-77.8330652",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 48 mins",
      "poi_biking_minutes": "4 hours 57 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 888-676-2466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWxlDOz1qYkRcXZTfH86_yE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_66964e49-c584-4e2e-8331-912aafa9e0e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Live Oak Bank",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1757 Tiburon Dr, Wilmington, NC 28403, USA",
      "poi_short_description": "Digital bank for small businesses offering loans, savings accounts, and CDs.",
      "poi_long_description": "Digital bank for small businesses offering loans, savings accounts, and CDs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-c811-719c-8a91-7b0043c465c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-c811-719c-8a91-7b0043c465c0",
        "storage_key": "property/6767906449167638/019fec2f-c811-719c-8a91-7b0043c465c0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.liveoak.bank/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1516226620458473861",
      "poi_item_slug": "live-oak-bank",
      "poi_latitude": "34.1997487",
      "poi_longitude": "-77.9021987",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "19 hours 23 mins",
      "poi_biking_minutes": "5 hours 1 min",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 866-518-0286",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWxlDOz1qYkRhRlr9xO4ChU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_a610751e-6f0c-4da1-83e7-e2f144cbff4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "Corning Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "310 N College Rd, Wilmington, NC 28405, USA",
      "poi_short_description": "Corning Inc. manufacturing plant on North College Road in Wilmington.",
      "poi_long_description": "Corning Inc. manufacturing plant on North College Road in Wilmington.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-c4d6-700d-ab67-9507c069ad99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-c4d6-700d-ab67-9507c069ad99",
        "storage_key": "property/6767906449167638/019fec2f-c4d6-700d-ab67-9507c069ad99.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.corning.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7354255846365679153",
      "poi_item_slug": "corning-inc",
      "poi_latitude": "34.2526692",
      "poi_longitude": "-77.8708503",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "18 hours 17 mins",
      "poi_biking_minutes": "4 hours 56 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 910-784-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUU8qJND0qYkRMU73TbqQD2Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_dab89ba2-5d7b-4ca0-8b56-f31d62eeb2d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "custom",
      "poi_name": "GE Aerospace - Wilmington",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3901 Castle Hayne Rd, Wilmington, NC 28401, USA",
      "poi_short_description": "GE Aerospace manufacturing plant on Castle Hayne Road, north of Wilmington.",
      "poi_long_description": "GE Aerospace manufacturing plant on Castle Hayne Road, north of Wilmington.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2f-c612-754e-b9af-f1e17e3b8e24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec2f-c612-754e-b9af-f1e17e3b8e24",
        "storage_key": "property/6767906449167638/019fec2f-c612-754e-b9af-f1e17e3b8e24.webp",
        "width": 1280,
        "height": 765
      },
      "poi_business_url": "https://www.geaerospace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7175006208120267596",
      "poi_item_slug": "ge-aerospace---wilmington",
      "poi_latitude": "34.322206",
      "poi_longitude": "-77.9237874",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "15 hours 58 mins",
      "poi_biking_minutes": "3 hours 58 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 910-819-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec2c-75a6-764f-8934-4a0c57fc5cd3",
        "storage_key": "property/6767906449167638/019fec2c-75a6-764f-8934-4a0c57fc5cd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK3StW8UfqokRTCM7qCG-kmM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_57a88618dbc8e1cb86bd6eb3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c19c68838b09fb1f3c0b951b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_5fae446603b33a5d910c64a1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_4546d06651285987a6497850",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_482cec1523a1fc3e54dcfc2b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_4e0f85fb491e0a013912314a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "rating": "5",
      "name": "Payton Moore",
      "text": "The homes are beautiful, spacious and I loved the self guided tour process. Moving is a stressful event, so of course I had a lot of questions and concerns but Trever was awesome at answering and explaining things to me! He was patient with us through this process and made it easier. Highly recommend!",
      "date": "2026-03-11",
      "title": "false"
    },
    {
      "id": "ec_20ec4fde88c0fa5a53b68fb1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "rating": "5",
      "name": "taylor retondo",
      "text": "I took a tour with Trever and was so pleasantly surprised by how much I enjoyed the experience from start to finish! I was not sure what to quite expect, but I didn't think I would walk away as impressed as I was. The neighborhood was cute and easy to access, the living spaces had good furnishings, an open layout, a spacious yard, and tasteful nooks that I could already see myself curling up into. Trever was thoughtful with his responses to my questions, down to wanting to know where some of the three-bedroom unit furniture was from since I liked it so much! Finding a place that feels thoughtfully built for how people like to live and design now can be a challenge, but I didn't have that here. If you find this review and are wondering if the tour is worth the effort, the answer is yes. I bet you will also be pleasantly surprised!",
      "date": "2025-04-15",
      "title": "false"
    },
    {
      "id": "ec_6899a8d88781b1adf70507fc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "rating": "5",
      "name": "Broch Baker",
      "text": "I loved the self-guided tour at Isabella Court! I walked through a 3-bedroom home at my own pace, taking in the spacious layout and modern kitchen. The master bedroom was huge, and the closet space was perfect. The process was super easy—just unlock, explore, and imagine living here.",
      "date": "2025-04-02",
      "title": "false"
    },
    {
      "id": "ec_d2d3b8c70363dee96bc567b8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "rating": "5",
      "name": "Katie Jones",
      "text": "Trever was beyond helpful during my in-person tour! He walked me through a 3-bedroom home, showing me the high ceilings, the huge walk-in closet, and the smart home features. He even gave me moving tips based on past residents’ experiences. Highly recommend working with him!",
      "date": "2025-04-10",
      "title": "false"
    },
    {
      "id": "ec_9cf2ef9d835d7caba7cb63cf",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "rating": "5",
      "name": "Lauren Maneval",
      "text": "We just moved into Isabella Court and couldn’t be happier. Trever was amazing throughout the entire leasing process — super responsive, knowledgeable, and made us feel completely at ease. The home is beautiful and the community is peaceful. Highly recommend!",
      "date": "2025-06-25",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [
    {
      "id": "custom_48084c09-129a-490d-9a70-fe2c8bfe665b",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_d77fb890-56d1-46ea-9f8d-c82838f81f5d",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_4463e05a-d382-4e14-8d47-03272f47160c",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_13213e1f-bcbf-4965-8d3a-b092aac84883",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_afff7b72-6bce-4083-82c5-166693ed0ecf",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_46a347c3-0751-4a61-910b-6a3c36143972",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_be6a449a-9efc-4058-978d-731eb0477a7b",
      "question": "Landscape Services",
      "answer": "Single-family homes: $97/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_bdb2b1e6-c366-4fb5-8373-33f5b60acc59",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_080fccfa-ea4f-49d2-b72d-ace2f9412451",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_dcacd6fd-bda0-4ca6-aac4-8124ae632aba",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_26fd3cba-f8f5-4daa-845b-ac7e0d942f55",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_b1455ce1-2c93-46bf-8293-d2a2db9ba711",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_f25f8c46-6a1d-4964-a455-db0a06bff492",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_e56dc74a-7066-4bb1-86aa-9c1c14718f9d",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_82c096d0-fd68-4689-8e03-80f0832c7274",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_b7deab94-bd19-4fd1-b7bb-75303507d78e",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_239670ca-0838-479d-bde4-3b090447d3fb",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_922294aa-38a3-4c68-89b5-6087bd39ca26",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_61aed47f-cde0-48e4-bcbb-863221bbe1ed",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_bdc15a4ebcdb0036b29c80da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "2451090",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_e0fe7ec51f04cfe95a4d171d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "2451088",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_3f75561ce0acf1b3e1237f7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "yardi",
      "external_id": "2451089",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-9a03-7494-9264-4c678bc3f71e",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Isabella Court Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638"
    },
    {
      "lead_collector_id": "01a0abe0-9a86-7565-82ca-10aa70742411",
      "lead_source": "LANDING_PAGE",
      "name": "Isabella Court Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "dog-park-apartments-leland-nc-isabella-court",
      "search_query": "dog park apartments Leland NC",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Leland, NC",
      "h2_subtitle": "Discover Isabella Court, ideal for pet owners in Leland. Enjoy easy access to a dog park and top-notch amenities.",
      "page_copy": "Welcome to Isabella Court, where finding dog park apartments in Leland, NC, transforms from a challenge to a delightful experience. For pet owners who love the idea of a community catering to their furry friends, Isabella Court is the ideal place. Our unique location offers convenient access to a nearby dog park, making daily walks and weekend playdates with your canine companion an absolute breeze. \n\nIn addition to our pet-friendly environment, we offer an array of luxurious amenities, ensuring human residents are just as pampered. Enjoy stunning granite countertops and relish the convenience of smart-home technology. Our concierge service is designed to cater to your everyday needs, while our security deposit alternative offers peace of mind. Embrace the ease of living with professional lawn maintenance, allowing you more time to spend exploring Brunswick County's pet-friendly spots. Choose Isabella Court for unmatched comfort and convenience in dog park apartments in Leland, NC.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments in Leland, NC | Isabella Court",
      "seo_description": "Explore dog park apartments at Isabella Court, Leland, NC, with granite countertops and smart-home tech.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "smart-home-technology-apartments-brunswick-county",
      "search_query": "smart home technology apartments Brunswick County",
      "category": "Amenity",
      "h1_title": "Smart Home Technology in Brunswick Apartments",
      "h2_subtitle": "Experience cutting-edge smart home technology in Brunswick County apartments. Enjoy modern features and luxury at Isabella Court.",
      "page_copy": "Discover the pinnacle of modern living with our smart home technology apartments in Brunswick County at Isabella Court. Imagine controlling your home's features with just a touch or voice command, providing you with unparalleled convenience and efficiency. Our state-of-the-art smart home systems enhance your living experience, making everyday life easier and more enjoyable.\n\nLocated in the charming city of Leland, Isabella Court goes beyond smart technology by offering luxurious comfort. Our granite countertops provide a stylish touch, while our concierge service attends to your needs. Enjoy the ease of a security deposit alternative and let our professional lawn maintenance team keep the community pristine. At Isabella Court, you'll find a home that seamlessly combines high-tech functionality with sophisticated amenities, ensuring you and your family live comfortably in the heart of Brunswick County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart Home Technology Apartments | Brunswick County",
      "seo_description": "Discover smart home technology apartments at Isabella Court in Brunswick County, featuring top amenities and cutting-edge innovations.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "granite-countertops-luxury-apartments-28451",
      "search_query": "granite countertops luxury apartments 28451",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Granite Countertops 28451",
      "h2_subtitle": "Explore luxury apartments in the 28451 area featuring stylish granite countertops at Isabella Court.",
      "page_copy": "Welcome to Isabella Court, where luxury meets style in the heart of the 28451 area. Among our premium features, you'll find elegant granite countertops that underscore the sophistication and quality of our luxury apartments. These stylish kitchen surfaces not only enhance the aesthetic appeal but also provide a durable and easy-to-maintain workspace.\n\nSet in the charming locale of Leland, Isabella Court offers more than just exquisite interiors. Our community is enriched with features such as smart-home technology, offering advanced convenience, and an innovative security deposit alternative that simplifies moving. Whether you're engaging with our attentive concierge service or enjoying the meticulous lawn maintenance, every aspect of Isabella Court is designed with your lifestyle in mind. Experience the epitome of luxury living with granite countertops in the vibrant 28451 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Granite Countertops | 28451",
      "seo_description": "Discover luxury apartments in 28451 at Isabella Court, featuring elegant granite countertops and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "spacious-closets-rentals-near-leland",
      "search_query": "spacious closets rentals near Leland",
      "category": "Amenity",
      "h1_title": "Rentals with Spacious Closets Near Leland",
      "h2_subtitle": "Find the perfect rentals near Leland with ample closet space at Isabella Court. Luxury and convenience await you here.",
      "page_copy": "At Isabella Court, we understand the importance of storage space, which is why our rentals near Leland feature spacious closets designed for convenience and organization. Whether you're a fashion enthusiast needing room for your wardrobe, or a couple seeking shared storage, our thoughtfully designed closets cater to all your needs, ensuring everything is easily accessible and neatly arranged.\n\nOur community is not just about abundant storage; we've paired luxurious design with practical features. Experience modern living with smart-home technology and enjoy stylish granite countertops in your kitchen. With a focus on security and convenience, the security deposit alternative and concierge service make your life easier. Plus, enjoy the manicured beauty of our grounds with professional lawn maintenance. Choose Isabella Court for your next rental near Leland, where ample storage meets modern luxury.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals with Spacious Closets Near Leland | Isabella Court",
      "seo_description": "Discover spacious closet rentals near Leland at Isabella Court. Enjoy our modern amenities and ample storage options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartment-homes-leland-nc",
      "search_query": "in-unit laundry apartment homes in Leland NC",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartment Homes in Leland NC",
      "h2_subtitle": "Discover the convenience of in-unit laundry apartment homes in Leland, NC at Isabella Court, where comfort and luxury meet.",
      "page_copy": "At Isabella Court, we offer exceptional apartment homes with the luxury of in-unit laundry, providing residents in Leland, NC with convenience and ease. Say goodbye to shared laundry spaces and enjoy the comfort of having your own washer and dryer just steps away, a true time-saver and game-changer in modern apartment living.\n\nOur community goes beyond providing essential conveniences. Experience the elegance of granite countertops, the convenience of smart-home technology, and the peace of mind with a security deposit alternative. Our residents appreciate the attention to detail in services like our concierge service and professional lawn maintenance, all designed to enhance daily living. Situated in the vibrant city of Leland, NC, Isabella Court combines top-notch amenities and a prime location, ensuring a remarkable living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Leland NC | Isabella Court",
      "seo_description": "Enjoy in-unit laundry at Isabella Court in Leland, NC. Discover ultimate convenience and modern amenities at our premier apartment homes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-leland-nc",
      "search_query": "three bedroom apartments leland nc",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Leland, NC",
      "h2_subtitle": "Explore spacious three bedroom apartments in Leland, NC at Isabella Court, offering luxurious living and modern amenities.",
      "page_copy": "Looking for spacious three bedroom apartments in Leland, NC? Isabella Court has you covered. Our thoughtfully designed three-bedroom homes offer ample space and style, perfect for families or professionals seeking extra room. Each apartment is crafted with you in mind, featuring an open floor plan that promotes both comfort and functionality with room for everyone.\n\nLocated in the charming town of Leland, Isabella Court seamlessly blends luxury with convenience. Enjoy premium amenities such as granite countertops that bring elegance to your kitchen, along with the latest in smart-home technology. Benefit from our innovative security deposit alternative and full concierge service that simplify the moving experience. Plus, with lawn maintenance taken care of, you can spend more time enjoying the comforts of your new home. Discover the ideal living space in our three-bedroom apartments at Isabella Court.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Leland, NC | Isabella Court",
      "seo_description": "Find spacious three bedroom apartments in Leland, NC at Isabella Court. Enjoy modern amenities and a comfortable living space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-brunswick-county",
      "search_query": "four bedroom apartments brunswick county",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments in Brunswick County",
      "h2_subtitle": "Discover versatile four bedroom apartments in Brunswick County at Isabella Court, ideal for families or shared living.",
      "page_copy": "Searching for four bedroom apartments in Brunswick County? Isabella Court offers the perfect solution with spacious accommodations that suit larger households or those in need of extra space. Our four-bedroom layouts provide flexibility and privacy, making them ideal for families or roommates seeking a comfortable and stylish living environment.\n\nLocated within the welcoming community of Brunswick County, Isabella Court combines refined living with practical features. Enjoy the sophistication of granite countertops in the kitchen, paired with smart-home technology that brings convenience right to your fingertips. Our community features a security deposit alternative and concierge service, designed to make life easier. Additionally, enjoy professionally maintained lawns that enhance our beautifully landscaped surroundings. Choose Isabella Court for your next home and experience the premium features of our four-bedroom apartments.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in Brunswick County | Isabella Court",
      "seo_description": "Explore spacious four bedroom apartments in Brunswick County at Isabella Court, ideal for families or shared living arrangements.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "apartments-near-leland-center-brunswick-community-college-nc",
      "search_query": "apartments near Leland Center Brunswick Community College NC",
      "category": "School",
      "h1_title": "Apartments Near Leland Center, Brunswick CC",
      "h2_subtitle": "Find apartments near Leland Center, Brunswick Community College NC at Isabella Court, offering convenience and luxury.",
      "page_copy": "Looking for apartments near Leland Center, Brunswick Community College NC? Isabella Court provides the ideal location, blending convenience with luxury living. Just a short distance from the college, our community offers easy access for students and staff, ensuring a hassle-free commute.\n\nAt Isabella Court, enjoy a host of amenities that elevate the apartment living experience. Revel in the modern comforts of granite countertops and the latest smart-home technology, perfect for contemporary lifestyles. With our security deposit alternative and attentive concierge service, moving in becomes a breeze. Residents also benefit from our professional lawn maintenance, allowing you more time to enjoy local attractions and the surrounding city of Leland. Discover Isabella Court, where proximity to education meets premium apartment living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Leland Center, Brunswick CC | Isabella Court",
      "seo_description": "Discover convenient living near Leland Center at Brunswick Community College NC with Isabella Court's premium apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "apartments-near-northwest-district-park-leland",
      "search_query": "apartments near northwest district park leland",
      "category": "Park",
      "h1_title": "Apartments Near Northwest District Park",
      "h2_subtitle": "Enjoy the perfect blend of nature and modern living at Isabella Court, ideally located near Northwest District Park in Leland, NC.",
      "page_copy": "Are you seeking apartments near Northwest District Park in Leland? Look no further than Isabella Court, where convenience meets comfort in a picturesque setting. Our community sits just moments away from the lush greenery and recreational opportunities of Northwest District Park, making it ideal for outdoor enthusiasts and families alike.\n\nAt Isabella Court, we provide a range of amenities designed to enhance your lifestyle. Each apartment is outfitted with elegant granite countertops and cutting-edge smart-home technology, reflecting a commitment to quality and innovation. Enjoy the ease of a security deposit alternative and the support of our dedicated concierge service. Additionally, our lawn maintenance service ensures immaculate surroundings, so you can spend more time exploring the nearby park or relaxing in your luxurious home. Experience the best of both worlds by living near nature's beauty and enjoying modern conveniences at Isabella Court.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northwest District Park, Leland | Isabella Court",
      "seo_description": "Live near Northwest District Park in Leland at Isabella Court. Enjoy the blend of nature's beauty and upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "apartments-close-to-leland-community-park-nc",
      "search_query": "apartments close to leland community park nc",
      "category": "Park",
      "h1_title": "Apartments Close to Leland Community Park",
      "h2_subtitle": "Discover the ideal living solution at Isabella Court, located close to Leland Community Park in NC, offering a perfect balance of leisure and luxury.",
      "page_copy": "Looking for apartments close to Leland Community Park, NC? Isabella Court offers a prime location with easy access to the park's scenic landscapes and recreational facilities. Whether you enjoy a leisurely stroll, a brisk jog, or family picnics, living near this popular park provides numerous outdoor opportunities just minutes from your doorstep.\n\nAt Isabella Court, you will find upscale amenities that enhance your everyday life. Our apartments feature stunning granite countertops and state-of-the-art smart-home technology, catering to both comfort and convenience. We also offer a stress-free moving experience with a security deposit alternative, alongside our responsive concierge service. Regular lawn maintenance means immaculate surroundings without the hassle, allowing more time to explore the area's attractions. Choose Isabella Court for a comfortable lifestyle enriched by proximity to Leland Community Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Leland Community Park, NC | Isabella Court",
      "seo_description": "Find your ideal home at Isabella Court, close to Leland Community Park, NC. Experience leisure and luxury living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "apartments-near-phoenix-park-brunswick-county",
      "search_query": "apartments near phoenix park brunswick county",
      "category": "Park",
      "h1_title": "Apartments Near Phoenix Park, Brunswick County",
      "h2_subtitle": "Isabella Court offers the perfect apartments near Phoenix Park in Brunswick County, combining convenience with contemporary living.",
      "page_copy": "Searching for apartments near Phoenix Park in Brunswick County? Isabella Court presents an excellent choice, combining the tranquility of park-side living with the sophistication of modern amenities. Located conveniently close to Phoenix Park, our community allows you to enjoy nature's beauty while maintaining easy access to everything you need in Brunswick County.\n\nIsabella Court stands out with its luxurious features such as granite countertops and advanced smart-home technology, creating a seamless living experience. We simplify your move with a security deposit alternative and offer an around-the-clock concierge service to cater to all your needs. Our meticulous lawn maintenance keeps the community looking pristine, letting you focus on what matters most. Dive into a comfortable, well-rounded lifestyle at Isabella Court, where proximity to Phoenix Park enhances your day-to-day enjoyment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Phoenix Park, Brunswick County | Isabella Court",
      "seo_description": "Live at Isabella Court, near Phoenix Park in Brunswick County. Enjoy modern amenities just moments from natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167638",
      "source": "generator",
      "page_item_url": "apartments-near-brunswick-county-parks-rec-28451",
      "search_query": "apartments near brunswick county parks & rec 28451",
      "category": "Park",
      "h1_title": "Apartments Near Brunswick County Parks & Rec",
      "h2_subtitle": "Live close to Brunswick County Parks & Rec in the 28451 area at Isabella Court. Enjoy a lifestyle that offers both recreational access and modern amenities.",
      "page_copy": "Looking for apartments near Brunswick County Parks & Rec in the 28451 area? Isabella Court is your perfect match, offering a remarkable blend of accessibility and upscale living. With Brunswick County Parks & Rec nearby, residents can take full advantage of a variety of recreational activities and natural beauty.\n\nIsabella Court boasts an array of premium amenities designed to elevate your lifestyle. Our apartments feature stylish granite countertops and cutting-edge smart-home technology, ensuring a comfortable and connected home environment. Benefit from our security deposit alternative, which makes moving easier. Additional benefits like our concierge service and reliable lawn maintenance further streamline your living experience, leaving you with more time to explore parks and community activities. Experience an enriching lifestyle by choosing Isabella Court, where comfort meets convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brunswick County Parks & Rec | Isabella Court",
      "seo_description": "Isabella Court: Premier apartments near Brunswick County Parks & Rec, NC 28451. Enjoy modern living with easy access to recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977302776"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TPZ3PFGW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57156159150"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/jlw072qgv2y"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/93703446-ea1c-474a-98ab-c27c957e8ebf/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "ce8e47d8-c17f-11ef-884a-93a832a0b69a"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-313-6036"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "877-455-6850"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977302776",
  "custom_google_gtm_id": "GTM-TPZ3PFGW",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57156159150",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/jlw072qgv2y",
  "custom_self_guided_tour_url": "https://selftournow.com/property/93703446-ea1c-474a-98ab-c27c957e8ebf/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "ce8e47d8-c17f-11ef-884a-93a832a0b69a",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "833-313-6036",
  "custom_paid_social_tracking_phone_number": "877-455-6850",
  "custom_audioeye_site_id": "a2981059-c876-4a28-b7b3-d54cff6ef59a",
  "custom_audioeye_site_hash": "208ce504f6a5253b692c95ad21bd3a34"
};

export const generatedAt = '2026-10-29T18:34:06.992Z';
